import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  createComponent,
  ElementRef,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  DestroyRef,
  viewChild,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Modal } from 'flowbite';
import { objectToCamel } from 'ts-case-convert';
import {
  GeoJsonObject,
  IBase,
  IBreadcrumbItem,
  IClient,
  IProcessingOptions,
  IRouteAlteration,
  IUnsavedChangesGuarded,
  IRouteDetails,
  IRouteDraft,
  IRoutePreview,
  IRouteReorganizationNewRouteResult,
  IRouteScheduledUpdate,
  IRouteTimes,
  IServiceInfo,
  IServiceInfoDetail,
  isOutlineDrawn,
  ITown,
} from 'src/app/models';
import { IGtfsImportWarning, IServiceArea } from 'src/app/models';
import {
  Colors,
  CreationSegmentsType,
  ExpeditionType,
  FeatureProperty,
  FeatureType,
  GeometryType,
  isDoor2DoorExpeditionType,
  NotificationTypes,
  PhaseStatus,
  RouteEditMode,
  RouteReorganizationType,
  RouteSaveAction,
  RouteStatus,
  ServicesQueryParam,
  ServiceType,
  ServiceWizardStep,
  UserRole,
} from 'src/app/models/enums';
import { ModalEditTownComponent } from 'src/app/shared/modals/modal-edit-town/modal-edit-town.component';
import { ErrorsCode } from 'src/app/models/enums/errorsCode';
import { RoutesResolver, ServiceInfosResolver } from 'src/app/resolvers';
import {
  AuthService,
  CreateOptions,
  EventsOptions,
  LiteralService,
  MapHistoryService,
  MapUtilsService,
  OperationTrackingService,
  RouteReorganizationService,
  RouteService,
  ServiceWizardService,
  StorageService,
  TownsService,
  UsersService,
  UnsavedChangesService,
  UtilsService,
  VehiclesService,
  WebSocketService,
} from 'src/app/services';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { RouteGraphService, routeTimesOf } from 'src/app/services/route-design/route-graph.service';
import {
  initialServiceInfoCreate,
  initialServiceInfoDetailsState,
} from 'src/app/store/initialisation/service-infos';
import {
  initialRouteCreate,
  initialServicesState,
} from 'src/app/store/initialisation/services';
import { initialPartialRouteSetupConfig } from 'src/app/store/initialisation/setup';
import { environment } from 'src/environments/environment';
import { images } from 'src/images';
import { MultiConfigUpdateOptions } from 'src/app/shared/modals/modal-confirm-multi-config/modal-confirm-multi-config.component';
import { ModalExportGtfsComponent } from 'src/app/shared/modals/modal-export-gtfs/modal-export-gtfs.component';
import { ServiceRoutesDetailsComponent } from 'src/app/components/service/routes/service-routes-details/service-routes-details.component';
import { RouteAlterationDetailsComponent } from 'src/app/components/service/route-alterations/route-alteration-details/route-alteration-details.component';
import { RouteDesignToolbarComponent } from 'src/app/components/service/route-design/route-design-toolbar.component';
import { ModalNewTownComponent } from 'src/app/shared/modals/modal-new-town/modal-new-town.component';
import { ModalUploadExcelComponent } from 'src/app/shared/modals/modal-upload-excel/modal-upload-excel.component';
import { MarkerStopComponent } from 'src/app/components/markers';
import { parseId, parseServicesTownsFromStorage } from 'src/app/filters';
import { initialRouteAlterationCreate } from 'src/app/store/initialisation/alteration';
import { APP } from 'src/app/config/app';

// Namespaced so a town service terrain is never mistaken for a hidden route id
const TOWN_SERVICE_TERRAIN_PREFIX = 'town-service-';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ServicesComponent implements OnInit, AfterViewInit, OnDestroy, IUnsavedChangesGuarded {
  @ViewChild('exportGtfsModal') exportGtfsModal: ModalExportGtfsComponent;
  @ViewChild('newTownModalComponent')
  newTownModalComponent: ModalNewTownComponent;
  @ViewChild('importExcelModalComponent')
  importExcelModalComponent: ModalUploadExcelComponent;
  @ViewChild(ServiceRoutesDetailsComponent)
  routeDetails: ServiceRoutesDetailsComponent;
  @ViewChild(RouteAlterationDetailsComponent)
  alterationDetails: RouteAlterationDetailsComponent;
  private readonly routeDesignToolbar = viewChild(RouteDesignToolbarComponent);

  public services = initialServiceInfoDetailsState;
  public map: google.maps.Map;
  public outlines: GeoJsonObject[] = [];
  public dataLayer: google.maps.Data;
  public displayedTerrainIds = new Set();

  public serviceInfoSelected?: IServiceInfoDetail;

  public routeSelected: any;
  public originalRouteSelected: any;
  public routes = initialServicesState;
  public newService: boolean = false;
  public newServiceObject = initialServiceInfoCreate();
  public newRoute: boolean = false;
  public newRouteObject = initialRouteCreate();

  public servicesGtfsModal: Modal;
  public servicesGtfsShowed = false;

  public servicesExportGtfsModal: Modal;
  public servicesExportGtfsShowed = false;

  public servicesImportExcelModal: Modal;
  public servicesImportExcelShowed = false;

  public changeStatusModal: Modal;
  public changeStatusShowed = false;

  public deleteServiceModal: Modal;
  public deleteServiceShowed = false;
  public deletingService = false;

  public deleteRouteModal: Modal;
  public deleteRouteShowed = false;
  public duplicateRouteModal: Modal;
  public duplicateRouteShowed = false;
  public duplicatingRoute = false;
  public routeToDuplicate?: IRouteDetails;
  public deletingRoute = false;

  public multiConfigModal: Modal;
  public multiConfigShowed = false;
  public multiConfigConfirmModal: Modal;
  public multiConfigConfirmShowed = false;
  public showMultiConfig = false;
  public editMultiConfig = true;
  public multiConfigObject = initialPartialRouteSetupConfig();
  public pendingMultiConfigData: any = null;
  public updatingMultiConfig = false;

  public changeStatusSelected = true;
  public changeStatusRouteIdSelected: number;

  public showRoutes = false;

  public towns: ITown[] = [];
  public selectedTowns: ITown[] = [];
  public clients: IClient[] = [];
  public images = images;
  public UserRole = UserRole;
  public role: UserRole;

  public newTownModal: Modal;
  public newTownShowed = false;
  public routeStopsTownStops: any[] = [];
  public routeStopsTownCenter?: { latitude: number; longitude: number };
  public orderedStopsOpenRequest = 0;
  public orderedStopsApplying = false;
  public wizardServiceInfo: any = null;
  public wizardRoute: any = null;
  public wizardBackwardsRoute: any = null;
  private wizardRouteTownId: number | null = null;
  // How the forward segments were drawn, so the backwards route is seeded the same way
  private wizardRouteCreationType: CreationSegmentsType | null = null;
  private wizardContinueSubscription?: Subscription;
  private wizardBackSubscription?: Subscription;
  private returningToWizardServiceStep = false;
  public restoringWizardRouteStep = false;
  public creatingQuickService = false;
  public creatingTown = false;

  public editTownModal: Modal;
  public editTownShowed = false;
  public savingTown = false;
  public townBeingEdited: any = null;
  private readonly editTownModalComponent = viewChild.required(ModalEditTownComponent);

  public deletingTown = false;

  public editService = false;
  public editRoute = false;

  public exportingGTFS = false;
  public importingGTFS = false;
  public loadingDetail = '';
  readonly deletionPercentage = signal<number | null>(null);
  readonly deletionDetail = signal('');
  public importGtfsWarnings: IGtfsImportWarning[] = [];
  public importingExcel = false;
  public loadingPercentage: number = 0;
  public phaseStatus: PhaseStatus = PhaseStatus.IN_PROGRESS;
  public changingStatus = false;

  public previewChanges: IRoutePreview[] = [];
  public loadingPreview = false;
  private previewOperationId?: string;
  public confirmStep = 1;
  public confirmChangesModalShowed = false;
  public confirmChangesModal: Modal;
  public loadingSave = false;
  public loadingRouteTimes = false;

  public routeTimes: IRouteTimes | null = null;
  public maxTimeExceededModal: Modal;
  public maxTimeExceededModalShowed = false;
  public coverageExceedsMaxTimeModal: Modal;
  public coverageExceedsMaxTimeModalShowed = false;
  private coverageExceedsMaxTimeAccepted = false;
  private pendingSaveAfterCoverageConfirmation: { event: any; action: RouteSaveAction } | null = null;

  public userStatus = true;

  public serviceIdToDelete: number | undefined;
  public routeIdToDelete: number | undefined;

  public routeDesign: RouteEditMode | null = null;
  public routeDetailsWidth = 32;
  public routeDetailsClosed = false;
  private _cleanupFullscreen: (() => void) | null = null;
  private loadGeneration = 0;

  public isLoadingOutlinesAndTerrains = false;

  private queryParamsSub?: Subscription;
  private paramsSub?: Subscription;

  public RouteEditMode = RouteEditMode;

  public alterations: IRouteAlteration[] = [];
  public selectedAlteration: IRouteAlteration | undefined = undefined;
  public requestedAlterationId: number | null = null;
  private alterationLoadGeneration = 0;
  public originalAlteration: IRouteAlteration | undefined = undefined;
  public newAlterationObject = initialRouteAlterationCreate();
  public newAlteration: boolean = false;
  public editAlteration: boolean = false;
  public alterationChanged: boolean = false;
  private newAlterationBaseline = '';
  public alterationDetailsClosed: boolean = true;
  public isDuplicatingAlteration: boolean = false;
  public deletingAlteration = false;
  public confirmChangesTitle = '';

  public routeDraft: IRouteDraft | null = null;
  public routeScheduled: IRouteScheduledUpdate | null = null;
  // Route detail fetched for the editor: its terrain carries every town stop next to the route features
  private routeDesignDetail: IRouteDetails | null = null;
  public selectedRouteStatus: RouteStatus = RouteStatus.ACTIVE;
  public saveAction: RouteSaveAction = RouteSaveAction.UPDATE;
  public scheduleDateTime: Date | null = null;
  public RouteSaveAction = RouteSaveAction;
  private routeVersionLoadGeneration = 0;

  private get selectedRouteVersionTerrain(): GeoJsonObject | undefined {
    if (this.selectedRouteStatus === RouteStatus.DRAFT)
      return this.routeDraft?.terrain;
    if (this.selectedRouteStatus === RouteStatus.SCHEDULED)
      return this.routeScheduled?.terrain;
    return undefined;
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public literalService: LiteralService,
    private mapUtilsService: MapUtilsService,
    private usersService: UsersService,
    private routeService: RouteService,
    private serviceInfoService: ServiceInfoService,
    private serviceInfosResolver: ServiceInfosResolver,
    private storageService: StorageService,
    private routesResolver: RoutesResolver,
    private utilsService: UtilsService,
    public eventsOptions: EventsOptions,
    private cdr: ChangeDetectorRef,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private townsService: TownsService,
    private authService: AuthService,
    private webSocketService: WebSocketService,
    private operationTrackingService: OperationTrackingService,
    private mapHistoryService: MapHistoryService,
    private createOptions: CreateOptions,
    private vehiclesService: VehiclesService,
    private routeGraphService: RouteGraphService,
    public serviceWizardService: ServiceWizardService,
    private routeReorganizationService: RouteReorganizationService,
    private unsavedChangesService: UnsavedChangesService,
    destroyRef: DestroyRef,
  ) {
    destroyRef.onDestroy(
      this.unsavedChangesService.register(
        () =>
          !!this.routeDesign &&
          (!!this.routeDesignToolbar()?.hasUnsavedChanges() || this.newAlterationFormChanged()),
      ),
    );
  }

  confirmLeave(nextUrl: string): boolean | Promise<boolean> {
    const nextPath = this.urlPath(nextUrl);
    const statePath = this.servicePath(
      this.serviceInfoSelected?.id,
      this.showRoutes,
      this.routeSelected?.id,
      this.routeDesign ?? undefined,
    ).join('/');
    if (nextPath === this.urlPath(this.router.url) || nextPath === statePath) return true;
    return this.unsavedChangesService.confirmDiscard(APP.ROUTE_DESIGN_UNSAVED_CHANGES_KEY);
  }

  private urlPath(url: string): string {
    return url.split(/[?#]/)[0];
  }

  private newAlterationFormChanged(): boolean {
    const creating = this.newAlteration || this.isDuplicatingAlteration;
    return creating && this.alterationFields(this.newAlterationObject) !== this.newAlterationBaseline;
  }

  async onAlterationsGoBack() {
    if (!(await this.unsavedChangesService.confirmDiscard(APP.ROUTE_DESIGN_UNSAVED_CHANGES_KEY))) return;
    this.initEditMode(RouteEditMode.DESIGN);
  }

  async ngOnInit() {
    this.literalService.setTitle('sidebar.services', ' - NEMI Backoffice');
    this.wizardContinueSubscription =
      this.serviceWizardService.continueEventEmitter.subscribe(() =>
        this.onWizardContinue(),
      );
    this.wizardBackSubscription =
      this.serviceWizardService.backEventEmitter.subscribe(() =>
        this.onWizardBack(),
      );
    this.restoringWizardRouteStep = this.isPendingWizardRouteStepUrl();
    const pageContextLoaded = Promise.all([
      this.storageService.getRole().then((role) => (this.role = role)),
      this.usersService.getPossibleClientTowns().then((res) => {
        this.towns = res.towns.sort((firstItem: IBase, secondItem: IBase) =>
          firstItem.name!.localeCompare(secondItem.name!, undefined, {
            sensitivity: 'base',
          }),
        );
      }),
      this.usersService.getClients().then((clients) => {
        this.clients = clients;
        this.storageService.setClients(JSON.stringify(this.clients));
      }),
    ]);
    await this.initMap();
    this.services = this.activatedRoute.snapshot.data['services'];
    this.dataLayer = new google.maps.Data();
    this.dataLayer.setMap(this.map);

    if (this.restoringWizardRouteStep) {
      this.subscribeToPathParams();
      this.restoringWizardRouteStep = false;
    }
    await pageContextLoaded;

    const pageParam = this.activatedRoute.snapshot.queryParamMap.get('page');
    let initialPage = 1;
    if (pageParam) {
      const parsed = Number(pageParam);
      if (!isNaN(parsed) && parsed > 0) {
        initialPage = parsed;
      }
    }

    // Hydration from storage happens in servicesHydrationGuard before the resolver
    // fires, so there's exactly one API call per sidebar entry.
    // A failure here must not skip the subscriptions below: without them the page stops
    // reacting to the url altogether, so entering the design editor does nothing
    try {
      await this.filterByTowns(undefined, false, initialPage);
    } catch (error) {
      console.error(
        'Error loading the services for the selected areas:',
        error,
      );
    }

    // React to URL towns changes (back/forward, programmatic nav).
    this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe(
      (params) => {
        this.applyTownsFromUrl(params.get('towns') ?? '');
        this.applyEditTownFromUrl(params.get(ServicesQueryParam.EDIT_TOWN));
      },
    );

    if (!this.paramsSub) this.subscribeToPathParams();

    this.eventsOptions.updatedAreas$.subscribe((areas) => {
      if (this.newRoute) this.newRouteObject.areas = areas;
      else this.routeSelected.areas = areas;
    });
  }

  // Path params drive the detail / routes / design views.
  // Subscribing covers back/forward across path levels; the component is reused
  // (see CustomRouteReuseStrategy), so ngOnInit only runs once per visit.
  private subscribeToPathParams() {
    this.paramsSub = this.activatedRoute.paramMap.subscribe(() => {
      this.applyPathParamsFromUrl();
    });
  }

  private isPendingWizardRouteStepUrl(): boolean {
    return (
      !!this.wizardRouteStepFromUrl() &&
      !!this.serviceWizardService.pendingQuickCreation
    );
  }

  private wizardRouteStepFromUrl(): ServiceWizardStep | null {
    const params = this.activatedRoute.snapshot.params ?? {};
    if (params['routeNumber'] != null) return ServiceWizardStep.FORWARD_ROUTE;
    if (params['id'] !== 'new') return null;
    return this.wizardRouteStepForSubRoute(params['subRoute'] ?? null);
  }

  private async applyPathParamsFromUrl(): Promise<void> {
    const snapshot = this.activatedRoute.snapshot;
    const rawServiceId = snapshot.params['id'];
    const reorganizationStep = snapshot.params['routeNumber'] ?? null;
    const reorganizationIndex = Number(reorganizationStep) - 1;
    if (rawServiceId === 'new' || reorganizationStep) {
      const wizardSubRoute = snapshot.params['subRoute'] ?? reorganizationStep;
      const wizardRouteStep = this.wizardRouteStepFromUrl();
      if (!this.newService && !this.wizardServiceInfo) {
        const pendingQuickCreation =
          this.serviceWizardService.pendingQuickCreation;
        if (wizardRouteStep && pendingQuickCreation) {
          // Fresh component after coming back from the setup screen: restore the route step
          this.wizardServiceInfo = pendingQuickCreation.serviceInfo;
          this.wizardRoute = pendingQuickCreation.route;
          this.wizardBackwardsRoute =
            pendingQuickCreation.backwardsRoute ?? null;
          this.wizardRouteTownId =
            pendingQuickCreation.serviceInfo?.townId ?? null;
          await this.restoreWizardRouteStep(
            wizardRouteStep,
            reorganizationIndex,
          );
        } else if (reorganizationStep) {
          // Nothing prepared for this reorganization (e.g. a reload): start again from the source routes
          this.router.navigate(['/services', rawServiceId, 'reorganize'], {
            replaceUrl: true,
          });
        } else {
          await this.addService();
        }
        return;
      }
      if (
        wizardSubRoute === null &&
        this.wizardServiceInfo &&
        !this.newService
      ) {
        this.backToWizardServiceStep();
      } else if (wizardRouteStep) {
        if (
          this.newService &&
          this.serviceWizardService.step === ServiceWizardStep.SERVICE
        ) {
          // Browser forward from the service step into the route step
          if (this.isWizardServiceStepReady()) {
            await this.createService(this.newServiceObject);
          } else {
            this.router.navigate(['/services', 'new'], {
              queryParams: snapshot.queryParams,
              replaceUrl: true,
            });
          }
        } else if (
          this.wizardServiceInfo &&
          !this.newService &&
          (wizardRouteStep !== this.serviceWizardService.step ||
            !this.serviceWizardService.active ||
            (reorganizationStep &&
              reorganizationIndex !==
                this.serviceWizardService.reorganizationIndex))
        ) {
          // Browser back/forward between the route steps and the setup screen
          await this.restoreWizardRouteStep(
            wizardRouteStep,
            reorganizationIndex,
          );
        }
      }
      return;
    }
    const urlServiceId = rawServiceId ? Number(rawServiceId) : null;
    const urlSubRoute = snapshot.params['subRoute'] ?? null;
    const urlRouteId = snapshot.params['routeId']
      ? Number(snapshot.params['routeId'])
      : null;
    const urlShowRoutes = urlSubRoute === 'routes';
    const urlSegments = snapshot.url.map((s) => s.path);
    let urlEditMode: RouteEditMode | null = null;
    if (urlSegments.includes(RouteEditMode.DESIGN))
      urlEditMode = RouteEditMode.DESIGN;
    else if (urlSegments.includes(RouteEditMode.ALTERATIONS))
      urlEditMode = RouteEditMode.ALTERATIONS;
    else if (urlSegments.includes(RouteEditMode.RESTRICTIONS))
      urlEditMode = RouteEditMode.RESTRICTIONS;

    const currentServiceId = this.serviceInfoSelected?.id ?? null;
    const currentRouteId = this.routeSelected?.id ?? null;
    let serviceLoadedFromUrl = false;

    if (urlEditMode !== RouteEditMode.ALTERATIONS) this.resetAlterationState();

    // Sync service detail
    if (urlServiceId === null && (this.newService || this.wizardServiceInfo)) {
      this.closeServiceDetails();
    }

    if (currentServiceId !== urlServiceId) {
      if (urlServiceId === null) {
        // URL says no service - close everything below.
        this.serviceInfoSelected = undefined;
        this.hideOutlinesAndTerrains();
        this.selectedTownsZoom();
        this.editService = false;
        this.routeSelected = undefined;
        this.editRoute = false;
        this.showRoutes = false;
        this.routes = initialServicesState;
        this.routeDesign = null;
        this.updateBreadcrumb();
        return;
      }
      const serviceInfo =
        await this.serviceInfoService.getServiceInfo(urlServiceId);
      if (serviceInfo) {
        this.serviceInfoSelected = serviceInfo;
        serviceLoadedFromUrl = true;
      }
    }

    // Sync routes view
    if (urlShowRoutes !== this.showRoutes) {
      if (urlShowRoutes && this.serviceInfoSelected) {
        await this.showRoutesEvent(this.serviceInfoSelected, true, !urlRouteId);
      } else if (!urlShowRoutes) {
        this.showRoutes = false;
        this.routes = initialServicesState;
        this.routeSelected = undefined;
        this.editRoute = false;
        this.routeDesign = null;
      }
    }

    // Sync route detail
    if (currentRouteId !== urlRouteId) {
      if (urlRouteId) {
        await this.getRouteDetail(urlRouteId, true);
      } else {
        this.routeSelected = undefined;
        this.editRoute = false;
        this.routeDesign = null;
      }
    }

    // filterByTowns() already painted the map before the service was resolved, so repaint it here.
    if (serviceLoadedFromUrl && !urlShowRoutes && !urlRouteId) {
      this.showOutlinesAndTerrains(undefined, false);
    }

    // Sync edit mode
    if (urlEditMode !== this.routeDesign) {
      if (urlEditMode !== null) {
        this.initEditMode(urlEditMode, true, true);
      } else if (!this.newRoute) {
        this.routeDesign = null;
      }
    }

    this.updateBreadcrumb();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  private updateBreadcrumb(): void {
    if (!this.serviceInfoSelected) {
      this.storageService.clearBreadcrumb();
      return;
    }

    const breadcrumbs: IBreadcrumbItem[] = [
      { labelKey: 'sidebar.services', url: '/services' },
    ];

    const serviceName = this.serviceInfoSelected?.name;
    const serviceId = this.serviceInfoSelected?.id;

    if (serviceName && serviceId) {
      if (this.routeSelected) {
        const params = this.activatedRoute.snapshot.queryParams;
        const parts: string[] = [];
        for (const [key, value] of Object.entries(params)) {
          if (Array.isArray(value)) {
            value.forEach((v) => parts.push(`${key}=${encodeURIComponent(v)}`));
          } else if (value !== null && value !== undefined) {
            parts.push(`${key}=${encodeURIComponent(value as string)}`);
          }
        }
        const queryParams = parts.length ? `?${parts.join('&')}` : '';
        const isAlterationsView =
          this.routeDesign === RouteEditMode.ALTERATIONS;
        const isRestrictionsView =
          this.routeDesign === RouteEditMode.RESTRICTIONS;
        breadcrumbs.push({
          label: serviceName,
          url: `/services/${serviceId}/routes${queryParams}`,
        });
        breadcrumbs.push({
          label: this.routeSelected.name,
          url:
            isAlterationsView || isRestrictionsView
              ? `/services/${serviceId}/routes/${this.routeSelected?.id}`
              : undefined,
        });
        if (isAlterationsView) {
          breadcrumbs.push({ labelKey: 'services.routes.design.alterations' });
        } else if (isRestrictionsView) {
          breadcrumbs.push({ labelKey: 'services.routes.restrictions.title' });
        }
      } else if (this.showRoutes) {
        breadcrumbs.push({ label: serviceName });
      } else {
        breadcrumbs.push({ label: serviceName });
      }
    }

    this.storageService.setBreadcrumb(breadcrumbs);
  }

  async getUpdatedHiddenRoutes(serviceRoutes?: any[]) {
    const storedHiddenRoutes = JSON.parse(
      (await this.storageService.getHiddenRoutes()) || '[]',
    );
    let updatedHiddenRoutes: string[] = [...storedHiddenRoutes];

    if (serviceRoutes) {
      const newlyHiddenRoutes = serviceRoutes
        .filter((r) => r.visible === false)
        .map((r) => r.id);

      updatedHiddenRoutes = [
        ...new Set([...storedHiddenRoutes, ...newlyHiddenRoutes]),
      ];

      const reenabledRoutes = serviceRoutes
        .filter((r) => r.visible !== false)
        .map((r) => r.id);
      updatedHiddenRoutes = updatedHiddenRoutes.filter(
        (id) => !reenabledRoutes.includes(id),
      );

      await this.storageService.setHiddenRoutes(
        JSON.stringify(updatedHiddenRoutes),
      );
    }
    return updatedHiddenRoutes;
  }

  async showOutlinesAndTerrains(serviceRoutes?: any[], rightAlign?: boolean) {
    if (!this.map || this.isDesigningWizardRoute) return;
    const generation = ++this.loadGeneration;
    this.isLoadingOutlinesAndTerrains = true;
    try {
      if (generation !== this.loadGeneration) return;
      const townIds: number[] = [
        ...new Set([
          ...this.selectedTowns.map((town: ITown) => town.id),
          ...(this.serviceInfoSelected?.towns?.map((t) => t.id) || [
              this.serviceInfoSelected?.town?.id,
            ] ||
            []),
        ]),
      ].filter((id): id is number => id != null);
      if (
        (townIds.length === 0 || townIds.length > 1) &&
        !serviceRoutes &&
        !this.serviceInfoSelected
      ) {
        this.hideOutlinesAndTerrains();
        this.selectedTownsZoom();
        return;
      }

      let terrains: any[] = [];
      if (this.routeSelected) {
        terrains = [
          {
            terrain: this.routeSelected.terrain,
            outline: this.routeSelected.outline,
            color: this.serviceInfoSelected?.color,
          },
        ];
      } else if (this.serviceInfoSelected) {
        terrains = await this.serviceInfoService.getServiceInfoTerrains(
          this.serviceInfoSelected!.id!,
        );
        if (generation !== this.loadGeneration) return;
      } else if (townIds.length === 1) {
        const townServiceInfos = await this.townsService.getServices(
          townIds[0],
        );
        if (generation !== this.loadGeneration) return;
        terrains = this.buildTownServicesTerrains(townServiceInfos);
      }

      const updatedHiddenRoutes =
        await this.getUpdatedHiddenRoutes(serviceRoutes);
      if (generation !== this.loadGeneration) return;

      const visibleRoutes = terrains
        .filter((route) => !updatedHiddenRoutes.includes(route.id))
        .map((route) => ({
          ...route,
          terrain: route.terrain
            ? {
                ...route.terrain,
                features:
                  route.terrain.features?.filter(
                    (f: any) => f.properties?.type !== FeatureType.TOWN_STOP,
                  ) ?? [],
              }
            : route.terrain,
        }));
      this.clearOutlinesAndTerrains();
      this.setRoutesAndOutlines(visibleRoutes);
      if (!this.fitToData(rightAlign)) this.selectedTownsZoom();
    } catch (error) {
      console.error('Error en showOutlinesAndTerrains:', error);
    } finally {
      if (generation === this.loadGeneration) {
        this.isLoadingOutlinesAndTerrains = false;
      }
    }
  }

  hideOutlinesAndTerrains() {
    this.loadGeneration++;
    this.clearOutlinesAndTerrains();
  }

  private clearOutlinesAndTerrains() {
    this.displayedTerrainIds.clear();
    this.map.data.forEach((feature: google.maps.Data.Feature) => {
      this.map.data.remove(feature);
    });
    this.mapUtilsService.clearClustersMarkers();
    this.clearMap();
  }

  // Stops are drawn neutral like the new booking map, so one element is built and cloned per stop
  // instead of instantiating a component for each: a town can hold hundreds of them
  private neutralStopMarkerTemplate?: HTMLElement;

  private buildNeutralStopMarker(): HTMLElement {
    if (!this.neutralStopMarkerTemplate) {
      const componentRef = createComponent(MarkerStopComponent, {
        environmentInjector: this.applicationRef.injector,
        elementInjector: this.injector,
      });
      componentRef.setInput('color', Colors.TRANSPARENT);
      componentRef.changeDetectorRef.detectChanges();
      this.neutralStopMarkerTemplate = componentRef.location.nativeElement;
    }
    return this.neutralStopMarkerTemplate!.cloneNode(true) as HTMLElement;
  }

  setRoutesAndOutlines(terrains: any[]) {
    let allFeatures: any[] = [];
    let stops: any[] = [];

    terrains.forEach((terrain: any) => {
      const terrainColor = this.serviceInfoSelected?.color || terrain.color || Colors.TRANSPARENT;
      if (this.displayedTerrainIds.has(terrain.id)) return;

      if (terrain.outline) {
        allFeatures.push(
          this.setOutlineProperties(
            terrain.outline,
            terrain.outline.properties,
            terrain.id,
            terrainColor,
          ),
        );
      }

      // Add terrain
      if (terrain.terrain?.features) {
        terrain.terrain.features.forEach((feature: any) => {
          feature.properties = feature.properties || {};

          if (feature.properties.type === FeatureType.STOP) {
            const alreadyDrawn = stops.find(
              (s) => s.id === feature.properties.id,
            );
            // A stop shared by several services shows one tag per service it takes part in
            if (alreadyDrawn) {
              if (
                terrain.serviceInfo &&
                !alreadyDrawn.serviceInfos.some(
                  (info: any) => info.id === terrain.serviceInfo.id,
                )
              ) {
                alreadyDrawn.serviceInfos.push(terrain.serviceInfo);
              }
              return;
            }

            stops.push({
              id: feature.properties.id,
              name: feature.properties.name,
              available: true,
              color: this.serviceInfoSelected?.color || Colors.TRANSPARENT,
              marker: this.buildNeutralStopMarker(),
              serviceInfos: terrain.serviceInfo ? [terrain.serviceInfo] : [],
              lat: feature.geometry.coordinates[1],
              lng: feature.geometry.coordinates[0],
            });
          }

          feature.properties.terrainId = terrain.id;
          if (feature.properties.type === FeatureType.SEGMENT || feature.geometry.type === GeometryType.LINE_STRING) {
            feature.properties.terrainColor = terrainColor;
          }
        });
        allFeatures = [...allFeatures, ...terrain.terrain.features];
      }

      this.displayedTerrainIds.add(terrain.id);
    });

    allFeatures = allFeatures.filter((feature) => feature.type === 'Feature');
    this.map.data.addGeoJson({
      type: 'FeatureCollection',
      features: allFeatures,
    });
    if (this.serviceInfoSelected) {
      this.mapUtilsService.clearClustersMarkers();
      this.eventsOptions.loadStops(
        false,
        stops,
        this.map,
        this.serviceInfoSelected.color,
      );
    } else {
      this.mapUtilsService.addStopsClustersMarkers(this.map, stops);
    }

    // Set style
    this.map.data.setStyle((feature: any) => {
      const type = feature.getProperty('type');

      if (type === FeatureType.STOP) {
        return {
          visible: false,
        };
      }

      if (type === FeatureType.OUTLINE) {
        return {
          strokeColor: feature.getProperty('outlineColor') || '#000000',
          strokeWeight: 2,
          strokeOpacity: 1,
          fillColor: feature.getProperty('outlineColor') || '#000000',
          fillOpacity: 0.1,
        };
      }

      return {
        strokeColor: feature.getProperty('terrainColor') || '#000000',
        strokeWeight: 5,
        strokeOpacity: 1.0,
      };
    });
  }

  // Town preview: the town's services with their areas and stops, like the new booking map
  private buildTownServicesTerrains(serviceInfos: IServiceInfo[]): any[] {
    return (serviceInfos ?? []).map((serviceInfo: IServiceInfo) => {
      const terrainId = `${TOWN_SERVICE_TERRAIN_PREFIX}${serviceInfo.id}`;
      const outlineFeatures = (serviceInfo.outlines ?? [])
        .filter((outline: any) => isOutlineDrawn(outline))
        .map((outline: any) =>
          this.setOutlineProperties(
            outline,
            outline.properties,
            terrainId,
            serviceInfo.color,
          ),
        );
      const stopFeatures = (serviceInfo.stops ?? [])
        .filter((stop: any) => stop?.location?.geometry?.coordinates)
        .map((stop: any) => ({
          [FeatureProperty.TYPE]: 'Feature',
          [FeatureProperty.GEOMETRY]: stop.location.geometry,
          [FeatureProperty.PROPERTIES]: {
            [FeatureProperty.ID]: stop.id,
            [FeatureProperty.NAME]: stop.name,
            [FeatureProperty.TYPE]: FeatureType.STOP,
          },
        }));
      const pathFeatures = (serviceInfo.servicePaths ?? [])
        .flatMap((path: any) => path?.features ?? [])
        .filter((feature: any) => feature?.geometry?.coordinates)
        .map((feature: any) => ({
          ...feature,
          [FeatureProperty.PROPERTIES]: { ...(feature.properties || {}), [FeatureProperty.TYPE]: FeatureType.SEGMENT }
        }));
      return {
        id: terrainId,
        color: serviceInfo.color,
        serviceInfo,
        terrain: { type: 'FeatureCollection', features: [...outlineFeatures, ...pathFeatures, ...stopFeatures] }
      };
    });
  }

  private setOutlineProperties(
    outline: any,
    properties: any,
    terrainId: number | string,
    color: string,
  ) {
    const result = {
      ...outline,
      properties: {
        ...(properties || {}),
        [FeatureProperty.TYPE]: FeatureType.OUTLINE,
        [FeatureProperty.ID]: FeatureType.OUTLINE,
        terrainId,
        [FeatureProperty.OUTLINE_COLOR]: color,
      },
    };

    this.utilsService.closeOutlineRings(result.geometry);
    return result;
  }

  async selectedTownsZoom(): Promise<void> {
    const towns = this.selectedTowns.filter((town: ITown) => town.latitude && town.longitude);
    if (towns.length === 0) return;
    const span = APP.TOWN_ZOOM_MIN_SPAN;
    const bounds = new google.maps.LatLngBounds();
    towns.forEach((town: ITown) => {
      bounds.extend({ lat: town.latitude - span, lng: town.longitude - span });
      bounds.extend({ lat: town.latitude + span, lng: town.longitude + span });
    });
    this.map.fitBounds(bounds, { top: 40, bottom: 30, left: 550, right: 0 });
  }

  async selectedRouteZoom(): Promise<void> {
    if (this.routeSelected) {
      const padding = { top: 40, bottom: 30, left: 50, right: 0 };
      const bounds = new google.maps.LatLngBounds();
      if (
        this.routeSelected.town.latitude &&
        this.routeSelected.town.longitude
      ) {
        bounds.union(
          new google.maps.LatLngBounds(
            new google.maps.LatLng(
              this.routeSelected.town.latitude,
              this.routeSelected.town.longitude,
            ),
          ),
        );
      }
      this.map.fitBounds(bounds, padding);
      this.map.setZoom(Math.min(this.map.getZoom()!, 15));
    }
  }

  async initMap() {
    const [{ Map }, town] = await Promise.all([
      google.maps.importLibrary('maps') as Promise<google.maps.MapsLibrary>,
      this.usersService.getLoggedUserTown(),
    ]);
    const coords = {
      lat: town.latitude ? town.latitude : 41.4696546,
      lng: town.longitude ? town.longitude : 2.0596017,
    };
    this.map = new Map(document.getElementById('map') as HTMLElement, {
      center: coords,
      zoom: APP.DEFAULT_MAP_ZOOM,
      disableDefaultUI: true,
      zoomControl: true,
      cameraControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true,
      mapId: environment.mapId,
      clickableIcons: false,
    });
    this.map.addListener('click', () => {
      this.mapUtilsService.clearInfoWindows();
    });
  }

  private dedupeTerrainFeatures(terrain: GeoJsonObject): GeoJsonObject {
    const seenFeatureKeys = new Set<string>();
    const features = (terrain.features ?? []).filter((feature: any) => {
      const type = feature.properties?.type;
      if (type !== FeatureType.STOP && type !== FeatureType.SEGMENT)
        return true;
      const featureKey = `${type}:${feature.properties.id}`;
      if (seenFeatureKeys.has(featureKey)) return false;
      seenFeatureKeys.add(featureKey);
      return true;
    });
    return { ...terrain, features };
  }

  async initRouteMap() {
    const generation = ++this.loadGeneration;
    if (!this.map) await this.initMap();
    if (generation !== this.loadGeneration) return;
    this.eventsOptions.clearMap();
    let mapCenter = { lat: 41.4696546, lng: 2.0596017 };
    if (this.routeSelected && this.routeSelected.town) {
      mapCenter = {
        lat: this.routeSelected.town.latitude,
        lng: this.routeSelected.town.longitude,
      };
    } else if (this.serviceInfoSelected) {
      if (this.serviceInfoSelected.town) {
        mapCenter = {
          lat: this.serviceInfoSelected.town.latitude,
          lng: this.serviceInfoSelected.town.longitude,
        };
      } else {
        const townInfo: any = await this.townsService.getTown(
          this.serviceInfoSelected.towns[0].id!,
        );
        if (generation !== this.loadGeneration) return;
        mapCenter = { lat: townInfo.latitude, lng: townInfo.longitude };
      }
    }
    if (mapCenter.lat && mapCenter.lng) {
      this.map.setCenter(mapCenter);
      this.map.setZoom(15);
    } else {
      this.fitToData();
    }

    this.map.data.setStyle((feature: any) => {
      const type = feature.getProperty(FeatureProperty.TYPE);
      if (type === FeatureType.STOP || type === FeatureType.TOWN_STOP)
        return { visible: false };
      if (type === FeatureType.SEGMENT)
        return { strokeColor: '#280a54', strokeWeight: 4 };
      if (type === FeatureType.OUTLINE)
        return {
          strokeColor:
            feature.getProperty(FeatureProperty.OUTLINE_COLOR) || '#000000',
          strokeWeight: 2,
          strokeOpacity: 1,
          fillColor:
            feature.getProperty(FeatureProperty.OUTLINE_COLOR) || '#000000',
          fillOpacity: 0.1,
        };
      return {};
    });

    this.eventsOptions.serviceColor = this.serviceInfoSelected?.color;
    const isDesign = this.routeDesign === RouteEditMode.DESIGN;
    const townStops = await this.loadTownStopsContext();
    if ((isDesign && !this.newRoute) || !isDesign) {
      let terrains =
        this.routeDesignDetail?.terrain ?? this.routeSelected.terrain;
      if (!isDesign && !this.newAlteration) {
        terrains = this.selectedAlteration?.terrain;
      } else if (isDesign) {
        terrains = this.selectedRouteVersionTerrain ?? terrains;
      }
      (this.routeSelected.areas ?? []).forEach((area: IServiceArea, index: number) =>
        this.map.data.addGeoJson(
          this.utilsService.areaToFeature(
            area,
            `${FeatureType.OUTLINE}-${index}`,
            this.routeSelected.id,
            this.serviceInfoSelected!.color,
          ),
        ),
      );

      if (terrains) {
        this.map.data.addGeoJson(
          this.utilsService.syncTerrainSegmentEndpoints(
            this.dedupeTerrainFeatures(terrains),
          ),
        );
      }

      this.fitToData();
      await this.eventsOptions.loadSegmentAndStops(false, this.map);
      // Unconnected stops in the terrain are the town's: they only become route stops once connected
      if (isDesign) this.eventsOptions.demoteIsolatedRouteStops(this.demandStopsInRoute);
      else this.eventsOptions.demoteStopsToTown(this.routeTerrainTownStopIds());
      if (generation !== this.loadGeneration) return;
    }
    const showAllStops =
      this.newRoute || (this.routeSelected?.stops ?? []).length === 0;
    this.eventsOptions.applyMapConfig(this.map, townStops, showAllStops);
    // A route being created draws nothing of its own, so the town catalogue is what has to fit on screen:
    // centring on the town coordinates alone leaves the stops outside the viewport
    this.townStopsForFit = townStops;
    if (this.newRoute) this.fitToTownStops(townStops);
  }

  private townStopsForFit: any[] = [];

  private fitToTownStops(townStops: any[]): boolean {
    const bounds = new google.maps.LatLngBounds();
    (townStops ?? []).forEach((stop: any) => {
      const coordinates = stop?.geometry?.coordinates;
      if (Array.isArray(coordinates) && coordinates.length >= 2) {
        bounds.extend(new google.maps.LatLng(coordinates[1], coordinates[0]));
      }
    });
    if (bounds.isEmpty()) return false;
    this.map.fitBounds(bounds, {
      top: 40,
      bottom: 40,
      left: this.routeDetailsClosed ? 60 : 440,
      right: 40,
    });
    const zoom = this.map.getZoom();
    if (zoom !== undefined) this.map.setZoom(Math.min(zoom, 16));
    return true;
  }

  // A design session writes its demotions straight into the cached terrain, so the catalogue comes back typed either way
  private isTerrainStop(feature: any): boolean {
    return (
      feature?.properties?.type === FeatureType.STOP ||
      feature?.properties?.type === FeatureType.TOWN_STOP
    );
  }

  private routeTerrainTownStopIds(): number[] {
    const features = this.routeDesignDetail?.terrain?.features ?? [];
    const routeStopIds = new Set<number>();
    const keepAsRouteStop = (id: any) => {
      if (id != null) routeStopIds.add(Number(id));
    };

    features.forEach((feature: any) => {
      const properties = feature.properties;
      if (properties?.type === FeatureType.SEGMENT) {
        keepAsRouteStop(properties.start?.properties?.id);
        keepAsRouteStop(properties.end?.properties?.id);
        return;
      }
      if (properties?.type !== FeatureType.STOP) return;
      if (properties.start || properties.end || properties.inflexion)
        keepAsRouteStop(properties.id);
      (properties.alternatives ?? []).forEach((alternative: any) => {
        keepAsRouteStop(properties.id);
        keepAsRouteStop(alternative.properties?.id);
      });
    });

    return features
      .filter(
        (feature: any) =>
          this.isTerrainStop(feature) &&
          !routeStopIds.has(Number(feature.properties.id)),
      )
      .map((feature: any) => Number(feature.properties.id));
  }

  // Editing an existing route: the detail is fetched with the whole town catalogue inside its terrain; a new route fetches it from the town
  private async loadTownStopsContext(): Promise<any[]> {
    try {
      if (this.routeSelected?.id && !this.newRoute) {
        if (this.routeDesignDetail?.id !== this.routeSelected.id) {
          this.routeDesignDetail = (await this.routeService.getService(
            this.routeSelected.id,
            true,
          )) as IRouteDetails;
        }
        this.eventsOptions.markTownCatalogueLoaded();
        return (this.routeDesignDetail?.terrain?.features ?? []).filter(
          (feature: any) => this.isTerrainStop(feature),
        );
      }
      const managerClientId = this.editManagerClientId;
      const townCatalogueStops =
        this.editTownId > 0 && managerClientId
          ? await this.townsService.getTownStops(
              this.editTownId,
              managerClientId,
            )
          : [];
      return this.withWizardDesignedRouteStops(townCatalogueStops ?? []);
    } catch (error) {
      console.error('Error loading the town stop catalogue:', error);
      return [];
    }
  }

  // Routes designed earlier in the wizard are not saved yet, so their stops are only reused if they join the catalogue
  private withWizardDesignedRouteStops(townCatalogueStops: any[]): any[] {
    const catalogueStopIds = new Set(
      townCatalogueStops.map((stop: any) => stop.properties?.id),
    );
    const designedRouteStops = this.wizardDesignedRoutes()
      .flatMap((route: any) => route?.terrain?.features ?? [])
      .filter((feature: any) => {
        const stopId = feature.properties?.id;
        if (!this.isTerrainStop(feature) || catalogueStopIds.has(stopId))
          return false;
        catalogueStopIds.add(stopId);
        return true;
      });
    return [...townCatalogueStops, ...designedRouteStops];
  }

  private wizardDesignedRoutes(): any[] {
    const wizard = this.serviceWizardService;
    if (!wizard.active) return [];
    if (wizard.reorganization)
      return wizard.reorganizationRoutes.slice(0, wizard.reorganizationIndex);
    const backwardsStep = wizard.step === ServiceWizardStep.BACKWARDS_ROUTE;
    return backwardsStep ? [this.wizardRoute] : [];
  }

  private buildRoutePayload(route: IRouteDetails, terrain: any): IRouteDetails {
    return {
      ...route,
      terrain,
      outline: this.utilsService.cleanOutlineObject(route.outline),
    };
  }

  private get demandStopsInRoute(): boolean {
    const route = this.newRoute ? this.newRouteObject : this.routeSelected;
    return (
      isDoor2DoorExpeditionType(route?.expeditionType) &&
      !isOutlineDrawn(route?.outline)
    );
  }

  // Only the design editor has the whole town catalogue on the map; it tells the backend to manage it
  private get townStopsIncluded(): boolean {
    return (
      this.routeDesign === RouteEditMode.DESIGN &&
      !!this.eventsOptions.townCatalogueLoaded
    );
  }

  private async followDeletion(operationId: string): Promise<void> {
    await this.operationTrackingService.follow(operationId, (percentage, detail) => {
      this.deletionPercentage.set(percentage);
      this.deletionDetail.set(detail);
    });
  }

  private resetDeletionProgress() {
    this.deletionPercentage.set(null);
    this.deletionDetail.set('');
  }

  private showDeletionBlockedByBookings(error: any): boolean {
    const errorCode = error?.error?.error_code;
    if (
      ![
        ErrorsCode.ROUTE_HAS_BOOKINGS,
        ErrorsCode.SERVICE_INFO_HAS_BOOKINGS,
        ErrorsCode.TOWN_HAS_BOOKINGS,
      ].includes(errorCode)
    ) {
      return false;
    }
    this.utilsService.showNotification(
      images.notifications.warning,
      '',
      NotificationTypes.DANGER,
      this.literalService.get(`${errorCode}_ERROR.title`, true),
      this.literalService.get(`${errorCode}_ERROR.text`, true, {
        bookings: error.error.entity_info,
      }),
      undefined,
      false,
    );
    return true;
  }

  private buildRouteErrorText(error: any): string {
    if (error.error_code === ErrorsCode.START_OR_END_ON_DYNAMIC) {
      return this.literalService.get(
        `${error.error_code}_ERROR.${error.entity_info}Text`,
        true,
      );
    }
    if (
      error.error_code === ErrorsCode.STOP_IN_USE &&
      Array.isArray(error.entity_info)
    ) {
      const routes = error.entity_info
        .map((route: any) => route.name)
        .join(', ');
      return this.literalService.get(
        `${error.error_code}_ERROR.routesText`,
        true,
        { routes },
      );
    }
    // ALTERATION_OVERLAP and STOPS_MISSING_FROM_TOWN share 2007: alterations come as named entities, stops as names
    if (
      error.error_code === ErrorsCode.ALTERATION_OVERLAP &&
      Array.isArray(error.entity_info) &&
      error.entity_info.every((info: any) => info?.name)
    ) {
      const alterations = error.entity_info
        .map((alteration: any) => alteration.name)
        .join(', ');
      return this.literalService.get(
        `${error.error_code}_ERROR.alterationsText`,
        true,
        { alterations },
      );
    }
    if (
      error.error_code === ErrorsCode.STOPS_MISSING_FROM_TOWN &&
      Array.isArray(error.entity_info)
    ) {
      const stops = error.entity_info.join(', ');
      return this.literalService.get(
        `${error.error_code}_ERROR.stopsText`,
        true,
        { stops },
      );
    }
    return this.literalService.get(`${error.error_code}_ERROR.text`, true);
  }

  private fitToData(alignRight?: boolean): boolean {
    const bounds = new google.maps.LatLngBounds();
    const padding = { top: 40, bottom: 40, left: alignRight ? 700 : 40, right: 40 };

    this.map.data.forEach((feature: any) => {
      const geometry = feature.getGeometry();
      this.extendBounds(geometry, bounds);
    });

    if (bounds.isEmpty()) return false;
    this.map.fitBounds(bounds, padding);
    return true;
  }

  private extendBounds(geometry: any, bounds: google.maps.LatLngBounds): void {
    if (geometry instanceof google.maps.Data.Point) {
      bounds.extend(geometry.get());
    } else if (
      geometry instanceof google.maps.Data.MultiPoint ||
      geometry instanceof google.maps.Data.LineString ||
      geometry instanceof google.maps.Data.LinearRing
    ) {
      geometry
        .getArray()
        .forEach((latLng: google.maps.LatLng) => bounds.extend(latLng));
    } else if (
      geometry instanceof google.maps.Data.MultiLineString ||
      geometry instanceof google.maps.Data.Polygon
    ) {
      geometry.getArray().forEach((g: any) => this.extendBounds(g, bounds));
    } else if (geometry instanceof google.maps.Data.MultiPolygon) {
      geometry.getArray().forEach((g: any) => this.extendBounds(g, bounds));
    }
  }

  clearMap() {
    this.eventsOptions.clearMap();
  }

  async openRouteStopsModal() {
    await this.refreshOrderedStopsContext();
    this.orderedStopsOpenRequest++;
  }

  private async refreshOrderedStopsContext() {
    this.routeStopsTownStops = [];
    this.routeStopsTownCenter = undefined;
    if (this.editTownId > 0) {
      try {
        const townStops = await this.loadTownStopsContext();
        const seenStopNames = new Set<string>();
        const seenStopCoordinates = new Set<string>();
        this.routeStopsTownStops = (townStops ?? [])
          .map((stop: any) => ({
            id: stop.properties?.id,
            name: stop.properties?.name,
            latitude: stop.geometry?.coordinates?.[1],
            longitude: stop.geometry?.coordinates?.[0],
          }))
          .filter((stop: any) => {
            if (
              stop.id == null ||
              stop.latitude == null ||
              stop.longitude == null
            )
              return false;
            const normalizedName = this.utilsService.normalizeStopName(
              stop.name,
            );
            const coordinatesKey = `${this.utilsService.truncateCoordinate(stop.latitude)},${this.utilsService.truncateCoordinate(stop.longitude)}`;
            if (
              (normalizedName && seenStopNames.has(normalizedName)) ||
              seenStopCoordinates.has(coordinatesKey)
            )
              return false;
            if (normalizedName) seenStopNames.add(normalizedName);
            seenStopCoordinates.add(coordinatesKey);
            return true;
          });
      } catch {
        this.routeStopsTownStops = [];
      }
      try {
        const town: any = await this.townsService.getTown(this.editTownId);
        this.routeStopsTownCenter = {
          latitude: town.latitude,
          longitude: town.longitude,
        };
      } catch {
        this.routeStopsTownCenter = undefined;
      }
    }
  }

  async applyRouteStops(payload: any) {
    this.orderedStopsApplying = true;
    try {
      await this.executeApplyRouteStops(payload);
    } finally {
      this.orderedStopsApplying = false;
    }
  }

  private async executeApplyRouteStops(payload: any) {
    try {
      await google.maps.importLibrary('geometry');
    } catch {
      /* already loaded */
    }
    try {
      await this.eventsOptions.applyImportedStops(
        payload.stops.map((stop: any) => ({
          name: stop.name,
          latitude: stop.latitude,
          longitude: stop.longitude,
        })),
      );
    } catch (error) {
      console.error(
        'Error applying imported stops, placing them directly',
        error,
      );
    }
    const relocatedStopIds = new Set<number>();
    const placedStops = payload.stops.map((stop: any) => {
      const feature = this.findRouteStopFeature(stop);
      if (feature) {
        if (this.syncRouteStopPosition(feature, stop))
          relocatedStopIds.add(Number(feature.getProperty('id')));
        return feature;
      }
      return this.createOptions.addStop(
        this.map,
        { lat: stop.latitude, lng: stop.longitude },
        (this.eventsOptions.mapConfig as any).radius ?? APP.DEFAULT_STOP_RADIUS,
        stop.name,
      );
    });
    this.map.data.forEach((feature: any) => {
      if (feature.getProperty('type') === FeatureType.STOP) {
        feature.setProperty('start', false);
        feature.setProperty('end', false);
      }
    });
    payload.stops.forEach((stop: any, index: number) => {
      if (stop.inflexion) placedStops[index].setProperty('inflexion', true);
    });
    placedStops[0].setProperty('start', true);
    if (!payload.endStopMissing)
      placedStops[placedStops.length - 1].setProperty('end', true);
    const reusableSegments = this.replaceRouteStopsSegments(
      placedStops,
      payload.previousStopChains,
      relocatedStopIds,
    );
    const drivingSpeed =
      this.eventsOptions.mapConfig.drivingSpeed ?? APP.DEFAULT_DRIVING_SPEED;
    let totalWeightInSeconds = 0;
    for (let index = 0; index < placedStops.length - 1; index++) {
      const reusableSegment = reusableSegments.get(
        this.routeStopPairKey(
          Number(placedStops[index].getProperty('id')),
          Number(placedStops[index + 1].getProperty('id')),
        ),
      );
      if (reusableSegment) {
        totalWeightInSeconds += Number(
          reusableSegment.getProperty('weight') ?? 0,
        );
        continue;
      }
      const from = this.routeStopCoordinates(placedStops[index]);
      const to = this.routeStopCoordinates(placedStops[index + 1]);
      const originStop = this.createOptions.buildPointFeature(
        Number(placedStops[index].getProperty('id')),
        from,
        this.routeStopProperties(placedStops[index], from),
      );
      const destinationStop = this.createOptions.buildPointFeature(
        Number(placedStops[index + 1].getProperty('id')),
        to,
        this.routeStopProperties(placedStops[index + 1], to),
      );
      let segment: any;
      try {
        segment = await this.createOptions.addSegment(
          this.map,
          from,
          to,
          originStop,
          destinationStop,
          [],
          payload.creationType,
          drivingSpeed,
        );
      } catch (error) {
        console.error(
          'Error creating segment with google routing, falling back to a straight line',
          error,
        );
        segment = await this.createOptions.addSegment(
          this.map,
          from,
          to,
          originStop,
          destinationStop,
          [],
          CreationSegmentsType.MANUAL,
          drivingSpeed,
        );
      }
      totalWeightInSeconds += Number(segment.getProperty('weight') ?? 0);
    }
    this.eventsOptions.removeDuplicatedTownStops();
    await this.eventsOptions.loadSegmentAndStops(true, this.map);
    this.eventsOptions.updateMarkers();
    // The toolbar only notices map changes through the eventsOptions streams; without this
    // the applied stops never refresh the terrain snapshot and the save button stays disabled
    this.eventsOptions.onAddStop.next();
    if (!payload.endStopMissing) {
      const initialStopName = placedStops[0].getProperty('name');
      const finalStopName =
        placedStops[placedStops.length - 1].getProperty('name');
      this.newRouteObject.name = `${initialStopName} -> ${finalStopName}`;
    }
    if (this.newRoute) this.newRouteObject = { ...this.newRouteObject };
    // maxTime is only raised to cover the path time, never lowered: a higher value may be on purpose
    this.onRouteMaxTimeRaised(Math.floor(totalWeightInSeconds / 60) + 1);
  }

  onRouteMaxTimeRaised(requiredMinutes: number) {
    const targetRoute: any = this.newRoute
      ? this.newRouteObject
      : this.routeSelected;
    if (!targetRoute || (targetRoute.maxTime ?? 0) >= requiredMinutes) return;
    if (this.newRoute) {
      this.newRouteObject = {
        ...this.newRouteObject,
        maxTime: requiredMinutes,
      };
    } else {
      this.routeSelected = { ...this.routeSelected, maxTime: requiredMinutes };
    }
  }

  private replaceRouteStopsSegments(
    placedStops: any[],
    previousStopChains: number[][] | undefined,
    relocatedStopIds: Set<number>,
  ): Map<string, any> {
    const placedStopIds = placedStops.map((stop) =>
      Number(stop.getProperty('id')),
    );
    const newPairKeys = new Set(
      placedStopIds
        .slice(1)
        .map((stopId, index) =>
          this.routeStopPairKey(placedStopIds[index], stopId),
        ),
    );
    const replacedPairKeys = previousStopChains
      ? new Set(
          previousStopChains.flatMap((chain) =>
            chain
              .slice(1)
              .map((stopId, index) =>
                this.routeStopPairKey(chain[index], stopId),
              ),
          ),
        )
      : null;
    const reusableSegments = new Map<string, any>();
    const obsoleteSegments: any[] = [];
    this.map.data.forEach((feature: any) => {
      if (feature.getProperty('type') !== FeatureType.SEGMENT) return;
      const startId = Number(feature.getProperty('start')?.properties?.id);
      const endId = Number(feature.getProperty('end')?.properties?.id);
      const pairKey = this.routeStopPairKey(startId, endId);
      const onNewPath = newPairKeys.has(pairKey);
      const touchesRelocatedStop =
        relocatedStopIds.has(startId) || relocatedStopIds.has(endId);
      if (replacedPairKeys && onNewPath && !touchesRelocatedStop)
        reusableSegments.set(pairKey, feature);
      else if (!replacedPairKeys || replacedPairKeys.has(pairKey) || onNewPath)
        obsoleteSegments.push(feature);
    });
    obsoleteSegments.forEach((segment) => {
      segment.getProperty('polyline')?.setMap?.(null);
      this.map.data.remove(segment);
    });
    return reusableSegments;
  }

  private routeStopPairKey(fromStopId: number, toStopId: number): string {
    return `${fromStopId}>${toStopId}`;
  }

  private routeStopCoordinates(feature: any): { lat: number; lng: number } {
    const position = feature.getGeometry().get();
    return { lat: position.lat(), lng: position.lng() };
  }

  private syncRouteStopPosition(feature: any, stop: any): boolean {
    const position = feature.getGeometry()?.get?.();
    if (!position) return false;
    const roundCoordinate = (value: number) => Math.round(value * 1e6) / 1e6;
    if (
      roundCoordinate(position.lat()) === roundCoordinate(stop.latitude) &&
      roundCoordinate(position.lng()) === roundCoordinate(stop.longitude)
    )
      return false;
    feature.setGeometry(
      new google.maps.Data.Point({ lat: stop.latitude, lng: stop.longitude }),
    );
    return true;
  }

  private routeStopProperties(
    feature: any,
    coordinates: { lat: number; lng: number },
  ) {
    return {
      id: Number(feature.getProperty('id')),
      name: feature.getProperty('name'),
      radius: feature.getProperty('radius') ?? APP.DEFAULT_STOP_RADIUS,
      type: FeatureType.STOP,
      demand: feature.getProperty('demand') ?? false,
      direction: feature.getProperty('direction') ?? 0,
      start: feature.getProperty('start') ?? false,
      end: feature.getProperty('end') ?? false,
      inflexion: feature.getProperty('inflexion') ?? false,
      merge: null,
      bidirectional: null,
      lat: coordinates.lat,
      lng: coordinates.lng,
    };
  }

  private findRouteStopFeature(stop: any): any {
    let match: any = null;
    const roundCoordinate = (value: number) => Math.round(value * 1e6) / 1e6;
    this.map.data.forEach((feature: any) => {
      if (match) return;
      if (feature.getProperty('type') !== FeatureType.STOP) return;
      const geometry = feature.getGeometry();
      if (!geometry || geometry.getType() !== 'Point') return;
      const position = geometry.get();
      const sameCoordinates =
        roundCoordinate(position.lat()) === roundCoordinate(stop.latitude) &&
        roundCoordinate(position.lng()) === roundCoordinate(stop.longitude);
      const sameName =
        (feature.getProperty('name') ?? '').toString().trim().toLowerCase() ===
        stop.name.trim().toLowerCase();
      if (sameCoordinates || sameName) match = feature;
    });
    return match;
  }

  openNewTownModal() {
    this.newTownModal = new Modal(document.getElementById('newTown'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.newTownShowed = false),
      onShow: () => (this.newTownShowed = true),
    });
    this.newTownModal.show();
  }

  async createTownAction(payload: any) {
    this.creatingTown = true;
    try {
      await this.townsService.createTown(payload);
      const res = await this.usersService.getPossibleClientTowns();
      this.towns = res.towns.sort((a: IBase, b: IBase) =>
        a.name!.localeCompare(b.name!, undefined, { sensitivity: 'base' }),
      );
      this.newTownModal.hide();
      this.newTownModalComponent?.reset();
      this.utilsService.showNotification(
        images.notifications.check,
        'towns',
        NotificationTypes.SUCCESS,
        'createSuccess.title',
        'createSuccess.text',
      );
    } catch (error: any) {
      if (error.error_code === ErrorsCode.ENTITY_ALREADY_EXISTS) {
        this.utilsService.showNotification(
          images.notifications.warning,
          `${error.error_code}_ERROR.areas`,
          NotificationTypes.DANGER,
        );
      } else {
        this.utilsService.showNotification(
          images.notifications.warning,
          'towns',
          NotificationTypes.DANGER,
          'createError.title',
          'createError.text',
        );
      }
    } finally {
      this.creatingTown = false;
    }
  }

  openEditTownModal(town: ITown) {
    this.changeEditTownInUrl(town.id!);
  }

  private changeEditTownInUrl(townId: number | null, replaceUrl = false) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [ServicesQueryParam.EDIT_TOWN]: townId },
      queryParamsHandling: 'merge',
      replaceUrl,
    });
  }

  private async applyEditTownFromUrl(rawTownId: string | null) {
    if (!rawTownId) {
      if (this.editTownShowed) this.editTownModal.hide();
      return;
    }
    const townId = Number(rawTownId);
    if (!(townId > 0) || this.role !== UserRole.SUPERADMIN) {
      this.changeEditTownInUrl(null, true);
      return;
    }
    if (this.townBeingEdited?.id === townId && this.editTownShowed) return;
    try {
      this.townBeingEdited = await this.townsService.getTown(townId);
    } catch {
      this.changeEditTownInUrl(null, true);
      return;
    }
    if (!this.editTownShowed) this.showEditTownModal();
  }

  private showEditTownModal() {
    this.editTownModal = new Modal(this.editTownModalComponent().modalElement().nativeElement, {
      placement: 'center',
      closable: false,
      onHide: () => {
        this.editTownShowed = false;
        if (this.activatedRoute.snapshot.queryParamMap.has(ServicesQueryParam.EDIT_TOWN)) {
          this.changeEditTownInUrl(null);
        }
      },
      onShow: () => (this.editTownShowed = true),
    });
    this.editTownModal.show();
  }

  async editTownAction(payload: any) {
    if (!this.townBeingEdited) return;
    this.savingTown = true;
    try {
      await this.townsService.updateTownConfig(
        this.townBeingEdited.id,
        payload,
      );
      const res = await this.usersService.getPossibleClientTowns();
      this.towns = res.towns.sort((a: IBase, b: IBase) =>
        a.name!.localeCompare(b.name!, undefined, { sensitivity: 'base' }),
      );
      this.editTownModal.hide();
      this.townBeingEdited = null;
      this.utilsService.showNotification(
        images.notifications.check,
        'towns',
        NotificationTypes.SUCCESS,
        'updateSuccess.title',
        'updateSuccess.text',
      );
    } catch (error: any) {
      if (error.error_code === ErrorsCode.ENTITY_ALREADY_EXISTS) {
        this.utilsService.showNotification(
          images.notifications.warning,
          `${error.error_code}_ERROR.areas`,
          NotificationTypes.DANGER,
        );
      } else {
        this.utilsService.showNotification(
          images.notifications.warning,
          'towns',
          NotificationTypes.DANGER,
          'updateError.title',
          'updateError.text',
        );
      }
    } finally {
      this.savingTown = false;
    }
  }

  async deleteTownAction() {
    if (!this.townBeingEdited) return;
    this.deletingTown = true;
    this.deletionPercentage.set(0);
    try {
      const operationId = await this.townsService.deleteTown(this.townBeingEdited.id);
      await this.followDeletion(operationId);
      const res = await this.usersService.getPossibleClientTowns();
      this.towns = res.towns.sort((a: IBase, b: IBase) =>
        a.name!.localeCompare(b.name!, undefined, { sensitivity: 'base' }),
      );
      this.editTownModal.hide();
      this.townBeingEdited = null;
      this.utilsService.showNotification(
        images.notifications.check,
        'towns',
        NotificationTypes.SUCCESS,
        'deleteSuccessTitle',
        'deleteSuccessText',
      );
    } catch (error) {
      console.error('Error deleting town:', error);
      if (this.showDeletionBlockedByBookings(error)) return;
      this.utilsService.showNotification(
        images.notifications.warning,
        'towns',
        NotificationTypes.DANGER,
        'deleteErrorTitle',
        'deleteErrorText',
      );
    } finally {
      this.deletingTown = false;
      this.resetDeletionProgress();
    }
  }

  async filterByTowns(
    event?: any,
    loadRoutes?: boolean,
    preservePage?: boolean | number,
  ) {
    const params = this.activatedRoute.snapshot.queryParamMap;
    const cache = parseServicesTownsFromStorage(
      await this.storageService.getServicesAreas().catch(() => null),
    );
    if (params.keys.some((key) => key !== ServicesQueryParam.EDIT_TOWN)) {
      const urlTownsRaw = params.get('towns') ?? '';
      const ids = urlTownsRaw
        ? urlTownsRaw
            .split(',')
            .map(Number)
            .filter((n) => !isNaN(n))
        : [];
      this.selectedTowns = ids
        .map(
          (id) =>
            cache.find((t) => t.id === id) ??
            this.towns.find((t) => t.id === id),
        )
        .filter((t): t is ITown => t != null);
    } else {
      this.selectedTowns = cache;
    }

    if (event) {
      const { dataset, checked } = event.target;
      // The URL drives the selection: applying it here too would make the navigation below
      // look like a no-op to applyTownsFromUrl, and the map would never repaint
      let nextTowns = [...this.selectedTowns];
      if (dataset.value === 'all') {
        nextTowns = [];
      } else {
        const town = this.towns.find((t: ITown) => t.id == dataset.value);
        const index = nextTowns.findIndex((t: ITown) => t.id == dataset.value);
        if (checked && town) {
          nextTowns.push(town);
        } else if (!checked && index !== -1) {
          nextTowns.splice(index, 1);
        }
      }
      await this.storageService.setServicesAreas(JSON.stringify(nextTowns));
      const townIds = nextTowns
        .map((t) => t.id)
        .filter((id): id is number => id != null)
        .join(',');
      if (this.serviceInfoSelected) {
        const serviceTownIds = new Set([
          ...(this.serviceInfoSelected.towns?.map((t: any) => t.id) ?? []),
          ...(this.serviceInfoSelected.town?.id != null
            ? [this.serviceInfoSelected.town.id]
            : []),
        ]);
        const stillValid = nextTowns.some((t) => serviceTownIds.has(t.id));
        if (!stillValid) {
          this.selectedTowns = nextTowns;
          this.showRoutes = false;
          this.routes = initialServicesState;
          this.serviceInfoSelected = undefined;
          this.routeSelected = undefined;
          this.editRoute = false;
          this.routeDesign = null;
          this.hideOutlinesAndTerrains();
          this.selectedTownsZoom();
          this.updateBreadcrumb();
          this.router.navigate(['/services'], {
            queryParams: { towns: townIds || null, page: null },
          });
          return;
        }
      }
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { towns: townIds || null, page: null },
        queryParamsHandling: 'merge',
      });
      return;
    }

    const page =
      typeof preservePage === 'number'
        ? preservePage
        : preservePage
          ? this.services?.pagination?.actualPage || 1
          : 1;
    await this.refreshServicesForSelection(page);
    if (loadRoutes) {
      this.getServices({ close: true });
    }
  }

  private async refreshServicesForSelection(page = 1): Promise<void> {
    const search =
      this.activatedRoute.snapshot.queryParamMap.get('search') ?? undefined;
    if (search) {
      // Preserve the active search query so this refresh doesn't wipe out filtered results.
      this.activatedRoute.snapshot.data['services'] = this.services;
      const result = await this.serviceInfosResolver.getServiceInfos(
        this.activatedRoute.snapshot,
        search,
      );
      if (result) this.services = result;
    } else {
      const result = await this.serviceInfosResolver.resolveForSelection(
        this.activatedRoute.snapshot,
        page,
        this.selectedTowns,
      );
      if (result) this.services = result;
    }
    this.showOutlinesAndTerrains();
  }

  closeModals() {
    if (this.servicesGtfsShowed) this.servicesGtfsModal.toggle();
  }

  async getServiceInfoDetail(serviceInfo: IServiceInfo) {
    if (this.newService) {
      this.newService = false;
      this.newServiceObject = initialServiceInfoCreate();
      this.wizardServiceInfo = null;
      this.wizardRoute = null;
      this.wizardBackwardsRoute = null;
      this.wizardRouteTownId = null;
      this.serviceWizardService.stop();
    }
    if (this.serviceInfoSelected) this.resetServiceDetails();
    this.eventsOptions.resetMapConfig();
    this.serviceInfoSelected = {
      ...(await this.serviceInfoService.getServiceInfo(serviceInfo.id!)),
    };
    this.showOutlinesAndTerrains(undefined, false);
    this.updateUrlWithService(serviceInfo.id!);
    this.updateBreadcrumb();
  }

  private resetServiceDetails() {
    if (this.newService) {
      this.newService = false;
      this.newServiceObject = initialServiceInfoCreate();
    } else {
      this.serviceInfoSelected = undefined;
      this.editService = false;
      this.closeRouteDetails();
      this.showRoutes = false;
      this.routes = initialServicesState;
    }
  }

  private updateUrlWithService(
    serviceId?: number,
    showRoutes?: boolean,
    routeId?: number,
    editMode?: RouteEditMode,
    resetRoutesPage?: boolean,
  ) {
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
    if (resetRoutesPage) delete queryParams['routesPage'];
    this.router.navigate(this.servicePath(serviceId, showRoutes, routeId, editMode), {
      queryParams,
      replaceUrl: true,
    });
  }

  private servicePath(
    serviceId?: number,
    showRoutes?: boolean,
    routeId?: number,
    editMode?: RouteEditMode,
  ): (string | number)[] {
    let path: (string | number)[] = ['/services'];
    if (!serviceId && this.wizardServiceInfo && !this.newService) {
      path = this.serviceWizardService.routeStepPath(
        this.serviceWizardService.step === ServiceWizardStep.BACKWARDS_ROUTE,
      );
    } else if (!serviceId && this.newService) {
      path.push('new');
    } else if (serviceId) {
      path.push(serviceId);
      if (showRoutes) {
        path.push('routes');
        if (routeId) {
          path.push(routeId);
          if (editMode) path.push(editMode);
        }
      }
    }
    return path;
  }

  async getRouteDetail(routeId: number, skipUrlUpdate?: boolean) {
    this.closeMultiConfig();
    this.routeDesignDetail = null;
    this.routeSelected = await this.routeService.getService(routeId);
    this.userStatus = this.routeSelected.active;
    this.showOutlinesAndTerrains();
    if (this.editRoute) this.editRoute = false;
    if (!skipUrlUpdate) {
      this.updateUrlWithService(this.serviceInfoSelected?.id, true, routeId);
    }
    this.updateBreadcrumb();
  }

  openGtfsModal() {
    this.servicesGtfsModal = new Modal(
      document.getElementById('servicesGtfs'),
      {
        placement: 'center',
        closable: false,
        onHide: () => (this.servicesGtfsShowed = false),
        onShow: () => (this.servicesGtfsShowed = true),
      },
    );
    this.servicesGtfsModal.toggle();
  }

  openExportGtfsModal() {
    this.servicesExportGtfsModal = new Modal(
      document.getElementById('servicesExportGtfs'),
      {
        placement: 'center',
        closable: false,
        onHide: () => (this.servicesExportGtfsShowed = false),
        onShow: () => {
          this.servicesExportGtfsShowed = true;
          this.exportGtfsModal.initModal();
        },
      },
    );
    this.servicesExportGtfsModal.toggle();
  }

  openImportExcelModal() {
    this.servicesImportExcelModal = new Modal(document.getElementById('servicesImportExcel'), {
      placement: 'center',
      closable: false,
      onHide: () => {
        this.servicesImportExcelShowed = false;
        this.importExcelModalComponent?.reset();
      },
      onShow: () => (this.servicesImportExcelShowed = true),
    });
    this.servicesImportExcelModal.toggle();
  }

  async importGTFS(event: any) {
    this.importingGTFS = true;
    this.importGtfsWarnings = [];
    this.loadingDetail = '';
    this.loadingPercentage = 0;
    this.phaseStatus = PhaseStatus.IN_PROGRESS;
    try {
      const operationId = await this.routeService.importServiceFromGtfs(
        event.files,
        event.clientId,
        event.snapToRoad,
        event.townId,
        event.townName,
        event.appIds,
      );
      const ephemeralToken =
        (await this.authService.getEphemeralToken()) as string;
      this.webSocketService.connect(operationId, ephemeralToken);
      this.webSocketService.getMessages().subscribe({
        next: (message: any) => this.handleImportGtfsProgress(message),
        error: () => this.finishImportGtfsWithError(),
      });
    } catch (e: any) {
      this.finishImportGtfsWithError(e?.error ?? e);
    }
  }

  private updateLoadingDetail(message: any) {
    this.loadingDetail = this.webSocketService.progressDetail(message);
  }

  private handleImportGtfsProgress(message: any) {
    this.loadingPercentage = message.total_percentage;
    this.phaseStatus = message.phase_status;
    this.updateLoadingDetail(message);
    if (this.phaseStatus === PhaseStatus.FAILED) {
      const error = this.utilsService.isJSON(message.progress_entity_data)
        ? JSON.parse(message.progress_entity_data)
        : undefined;
      this.finishImportGtfsWithError(error);
    } else if (this.webSocketService.isOperationCompleted(message)) {
      this.importingGTFS = false;
      // Routes the platform could not import exactly stay listed in the modal until the admin closes it
      this.importGtfsWarnings = objectToCamel(
        message.progress_entity_data?.warnings ?? [],
      ) as IGtfsImportWarning[];
      if (this.importGtfsWarnings.length === 0) this.servicesGtfsModal.toggle();
      this.utilsService.showNotification(
        images.notifications.check,
        'services.actions.uploadGtfs.create',
        NotificationTypes.SUCCESS,
      );
      this.filterByTowns();
    }
  }

  closeGtfsImportSummary() {
    this.importGtfsWarnings = [];
    this.servicesGtfsModal.toggle();
  }

  private finishImportGtfsWithError(error?: any) {
    this.importingGTFS = false;
    this.webSocketService.closeConnection();
    const detailKey = this.importGtfsErrorDetailKey(error);
    if (!detailKey) {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.actions.uploadGtfsError',
        NotificationTypes.DANGER,
      );
      return;
    }
    const title = this.literalService.get(
      'services.actions.uploadGtfsError.title',
      true,
    );
    const text = this.literalService.get(
      `services.actions.uploadGtfsError.${detailKey}`,
      true,
      { detail: error.entity_info },
    );
    this.utilsService.showNotification(
      images.notifications.warning,
      '',
      NotificationTypes.DANGER,
      title,
      text,
      undefined,
      false,
    );
  }

  private importGtfsErrorDetailKey(error: any): string | undefined {
    if (
      error?.error_code === ErrorsCode.ENTITY_ALREADY_EXISTS &&
      error.entity_type === 'Town'
    )
      return 'townExists';
    if (error?.error_code === ErrorsCode.INVALID_REQUEST)
      return 'invalidRequest';
    return undefined;
  }

  async importExcel(event: any) {
    this.importingExcel = true;
    this.loadingPercentage = 0;
    this.loadingDetail = '';
    this.phaseStatus = PhaseStatus.IN_PROGRESS;
    const { file, clientId, townId, townName, snapToRoad } = event;
    try {
      const resp: any = await this.routeService.importServiceFromExcel(file, clientId, snapToRoad, townId, townName);
      await this.connectAndHandleWebSocket(
        resp,
        () => {
          this.importingExcel = false;
          this.servicesImportExcelModal.toggle();
          this.utilsService.showNotification(images.notifications.check, 'services.actions.uploadExcel', NotificationTypes.SUCCESS);
          this.filterByTowns();
        },
        () => {
          this.importingExcel = false;
          this.utilsService.showNotification(images.notifications.warning, 'services.actions.uploadExcelError', NotificationTypes.DANGER);
        },
        (error?: any) => {
          this.importingExcel = false;
          this.makeImportExcelError(error);
        }
      );
    } catch(e: any) {
      this.importingExcel = false;
      this.makeImportExcelError(e?.error ?? e);
    }
  }

  makeImportExcelError(error: any) {
    switch (error?.error_code) {
      case ErrorsCode.INVALID_REQUEST:
        if (error.entity_type === 'Cell') {
          this.utilsService.showNotification(
            images.notifications.warning,
            `services.actions.uploadExcelError.${error.error_code}`,
            NotificationTypes.DANGER,
            undefined,
            undefined,
            error.entity_info,
          );
          return;
        }
        if (error.entity_type === 'UserDriver') {
          this.utilsService.showNotification(
            images.notifications.warning,
            'services.actions.uploadExcelError.noDriver',
            NotificationTypes.DANGER,
          );
          return;
        }
        break;
      case ErrorsCode.STOP_FAR_FROM_ROAD:
        if (error.entity_type === 'Stop') {
          this.showImportExcelStopError(error);
          return;
        }
        break;
      case ErrorsCode.STOP_NOT_ON_SHEET:
      case ErrorsCode.STOP_DUPLICATED_ON_PATH:
        this.showImportExcelStopError(error);
        return;
    }
    this.utilsService.showNotification(
      images.notifications.warning,
      'services.actions.uploadExcelError',
      NotificationTypes.DANGER,
    );
  }

  private showImportExcelStopError(error: any) {
    const title = this.literalService.get(
      `services.actions.uploadExcelError.${error.error_code}.title`,
      true,
    );
    const text = this.literalService.get(
      `services.actions.uploadExcelError.${error.error_code}.text`,
      true,
      { stopName: error.entity_info },
    );
    this.utilsService.showNotification(
      images.notifications.warning,
      '',
      NotificationTypes.DANGER,
      title,
      text,
      undefined,
      false,
    );
  }

  async exportGTFS(serviceIds: number[]) {
    this.exportingGTFS = true;
    try {
      const resp: any = await this.serviceInfoService.exportServiceFromGtfs(serviceIds);
      const onExportError = () => {
        this.exportingGTFS = false;
        this.utilsService.showNotification(images.notifications.warning, 'services.actions.exportGtfsError', NotificationTypes.DANGER);
      };
      await this.connectAndHandleWebSocket(
        resp,
        (message: any) => this.downloadGtfs(message.progress_entity_data),
        onExportError,
        (error?: any) => {
          if (!error) {
            onExportError();
            return;
          }
          this.exportingGTFS = false;
          this.utilsService.showNotification(images.notifications.warning, `${error.error_code}_ERROR`, NotificationTypes.DANGER);
        }
      );
    } catch(e: any) {
      this.exportingGTFS = false;
    }
  }

  private async downloadGtfs(endpoint: string) {
    const res = (await this.serviceInfoService.downloadGtfs(
      endpoint,
    )) as ArrayBuffer;
    this.utilsService.downloadDocument(res, 'gtfs', 'zip');
    this.exportingGTFS = false;
    this.servicesExportGtfsModal.toggle();
    this.utilsService.showNotification(
      images.notifications.check,
      'services.actions.exportGtfs',
      NotificationTypes.SUCCESS,
    );
    this.loadingPercentage = 0;
  }

  // Fingerprint of the inputs of the last routes fetch (without page). Used by
  // showRoutesEvent / getServices to collapse the pagination to "currentPage ···"
  // when filters change while leaving the numbered list visible on a pure
  // page change.
  private lastRoutesFilterFingerprint: string | null = null;

  private startRoutesFetch(serviceInfoId: number, searchValue?: string) {
    // Always show the skeleton during a fetch; the routes list has no polling
    // refresh so this is unconditional.
    const filterFingerprint = JSON.stringify({
      serviceInfoId,
      size: this.routes.pagination.numberOfElements,
      searchValue: searchValue ?? null,
    });
    const filtersChanged =
      filterFingerprint !== this.lastRoutesFilterFingerprint;
    this.routes = {
      ...this.routes,
      isFetchingServices: true,
      value: [],
      pagination: {
        ...this.routes.pagination,
        ...(filtersChanged ? { totalPages: 0, totalElements: 0 } : {}),
      },
    };
    this.lastRoutesFilterFingerprint = filterFingerprint;
  }

  async showRoutesEvent(
    serviceInfo: any,
    skipUrlUpdate?: boolean,
    showOutlines: boolean = true,
  ) {
    if (!skipUrlUpdate) this.closeServiceDetails();
    this.routes.pagination.numberOfElements = 6;
    this.routes.pagination.actualPage = 1;
    this.activatedRoute.snapshot.data['routes'] = this.routes;
    if (
      !this.serviceInfoSelected ||
      this.serviceInfoSelected.id !== serviceInfo.id
    )
      this.resetServiceDetails();
    this.startRoutesFetch(serviceInfo.id!);
    this.routes = await this.routesResolver.resolve(
      this.activatedRoute.snapshot,
      [serviceInfo.id!],
      skipUrlUpdate ? undefined : 1,
    );
    this.showRoutes = true;
    this.serviceInfoSelected = serviceInfo;
    if (showOutlines) this.showOutlinesAndTerrains(undefined, true);
    if (!skipUrlUpdate)
      this.updateUrlWithService(serviceInfo.id!, true, undefined, undefined, true);
    this.updateBreadcrumb();
  }

  async getServices(data: {
    page?: number;
    searchValue?: any;
    close?: boolean;
  }) {
    this.routes.pagination.numberOfElements = 6;
    this.routes.pagination.actualPage = data.page || 1;
    this.activatedRoute.snapshot.data['routes'] = this.routes;
    this.startRoutesFetch(this.serviceInfoSelected!.id!, data.searchValue);
    if (data.searchValue) {
      this.routes = await this.routesResolver.getRoutesSearch(
        this.activatedRoute.snapshot,
        [this.serviceInfoSelected!.id!],
        data.searchValue,
      );
    } else {
      this.routes = await this.routesResolver.resolve(
        this.activatedRoute.snapshot,
        [this.serviceInfoSelected!.id!],
        data.page,
      );
    }
    this.routes.value.length === 0 && data.close && this.closeRoutesModal();
  }

  async addService() {
    this.closeServiceDetails();
    this.newService = true;
    this.newServiceObject = initialServiceInfoCreate();
    this.serviceWizardService.start();
    this.serviceWizardService.canContinueEvaluator = () =>
      this.isWizardServiceStepReady();
    if (!this.router.url.startsWith('/services/new')) {
      this.storageService.setTitleKey('services.newService');
      this.router.navigate(['/services', 'new'], {
        queryParams: this.activatedRoute.snapshot.queryParams,
      });
    }
  }

  private isWizardServiceStepReady(): boolean {
    const serviceInfo = this.newServiceObject as any;
    const colorReady =
      serviceInfo?.serviceType === ServiceType.DISCRETIONARY ||
      !!serviceInfo?.color;
    return !!(
      serviceInfo?.clientId &&
      serviceInfo?.serviceType &&
      serviceInfo?.tag?.trim() &&
      serviceInfo?.townId &&
      colorReady
    );
  }

  private isWizardRouteStepReady(): boolean {
    const route = this.newRouteObject as any;
    return !!(
      route?.name?.trim() &&
      route?.expeditionType &&
      route.expeditionType !== ExpeditionType[''] &&
      route?.maxTime != null &&
      route?.maxVariationTime != null
    );
  }

  async onWizardContinue() {
    if (!this.serviceWizardService.canContinue) return;
    if (this.serviceWizardService.step === ServiceWizardStep.SERVICE) {
      await this.createService(this.newServiceObject);
    } else if (this.wizardRouteStepForSubRoute(this.wizardRouteSubRoute)) {
      await this.createRoute(this.newRouteObject);
    }
  }

  onWizardBack() {
    const wizard = this.serviceWizardService;
    if (
      wizard.reorganization &&
      wizard.step === ServiceWizardStep.FORWARD_ROUTE
    ) {
      // The URL change keeps what is drawn and restores the previous route
      if (wizard.reorganizationIndex > 0)
        this.router.navigate(
          wizard.reorganizationRoutePath(wizard.reorganizationIndex - 1),
          { queryParams: this.activatedRoute.snapshot.queryParams },
        );
      else this.backToReorganizationSources();
    } else if (
      this.serviceWizardService.step === ServiceWizardStep.FORWARD_ROUTE
    ) {
      this.backToWizardServiceStep();
    } else if (
      this.serviceWizardService.step === ServiceWizardStep.BACKWARDS_ROUTE
    ) {
      // The URL change restores the forward route step, keeping the drawn backwards route
      this.router.navigate(this.serviceWizardService.routeStepPath(), {
        queryParams: this.activatedRoute.snapshot.queryParams,
      });
    } else if (
      this.serviceWizardService.isSetupStep &&
      this.serviceWizardService.pendingQuickCreation
    ) {
      // Departures step on the setup screen, nothing created yet: return to the last route step
      this.router.navigate(
        this.serviceWizardService.routeStepPath(
          this.serviceWizardService.roundTrip,
        ),
      );
    }
  }

  private get wizardRouteSubRoute(): string {
    return this.serviceWizardService.step === ServiceWizardStep.BACKWARDS_ROUTE
      ? 'backwards-route'
      : 'route';
  }

  private get isDesigningWizardRoute(): boolean {
    return (
      !!this.wizardServiceInfo && this.routeDesign === RouteEditMode.DESIGN
    );
  }

  private wizardRouteStepForSubRoute(
    subRoute: string | null,
  ): ServiceWizardStep | null {
    if (subRoute === 'route') return ServiceWizardStep.FORWARD_ROUTE;
    if (subRoute === 'backwards-route')
      return ServiceWizardStep.BACKWARDS_ROUTE;
    return null;
  }

  private async restoreWizardRouteStep(
    step: ServiceWizardStep,
    reorganizationIndex?: number,
  ) {
    if (this.routeDesign === RouteEditMode.DESIGN) {
      // Leaving a route step through the URL: keep what is drawn before switching
      await this.captureWizardRouteFromMap();
      this.returningToWizardServiceStep = true;
      try {
        this.onCloseDesignRoute();
      } finally {
        this.returningToWizardServiceStep = false;
      }
    }
    this.serviceWizardService.roundTrip = !!this.wizardServiceInfo?.roundTrips;
    if (this.serviceWizardService.reorganization) {
      this.serviceWizardService.restore(step, reorganizationIndex);
      this.serviceWizardService.canContinueEvaluator = () =>
        this.isWizardRouteStepReady();
      await this.startWizardRouteStep();
      return;
    }
    if (
      step === ServiceWizardStep.BACKWARDS_ROUTE &&
      !this.wizardRoute?.terrain?.features?.length
    ) {
      // The backwards route is seeded from the forward one, which must exist first
      this.router.navigate(this.serviceWizardService.routeStepPath(), {
        queryParams: this.activatedRoute.snapshot.queryParams,
        replaceUrl: true,
      });
      return;
    }
    this.serviceWizardService.restore(step);
    this.serviceWizardService.canContinueEvaluator = () =>
      this.isWizardRouteStepReady();
    await this.startWizardRouteStep();
  }

  private async backToWizardServiceStep() {
    if (this.returningToWizardServiceStep) return;
    this.returningToWizardServiceStep = true;
    try {
      await this.captureWizardRouteFromMap();
      this.onCloseDesignRoute();
      this.newRoute = false;
      this.showRoutes = false;
      this.newService = true;
      this.newServiceObject = this.wizardServiceInfo;
      this.wizardServiceInfo = null;
      this.serviceWizardService.setStep(ServiceWizardStep.SERVICE);
      this.serviceWizardService.canContinueEvaluator = () =>
        this.isWizardServiceStepReady();
      this.router.navigate(['/services', 'new'], {
        queryParams: this.activatedRoute.snapshot.queryParams,
        replaceUrl: true,
      });
    } finally {
      this.returningToWizardServiceStep = false;
    }
  }

  private async backToReorganizationSources() {
    if (this.returningToWizardServiceStep) return;
    this.returningToWizardServiceStep = true;
    try {
      await this.captureWizardRouteFromMap();
      this.onCloseDesignRoute();
      this.newRoute = false;
      this.showRoutes = false;
      this.wizardServiceInfo = null;
      this.router.navigate([
        '/services',
        this.routeReorganizationService.draft?.serviceInfoId,
        'reorganize',
      ]);
    } finally {
      this.returningToWizardServiceStep = false;
    }
  }

  // The setup step checks the departure windows against them
  private async designedPathTimes(): Promise<
    Pick<IRouteDetails, 'minPathTime' | 'maxPathTime'>
  > {
    const graphRequest = this.eventsOptions.buildRouteGraphRequest();
    const times = graphRequest
      ? await this.routeGraphService.computeRouteTimes(graphRequest)
      : null;
    const toMinutes = (seconds?: number) =>
      seconds == null ? undefined : Math.ceil(seconds / 60);
    return {
      minPathTime: toMinutes(times?.minPathTime),
      maxPathTime: toMinutes(times?.maxPathTime),
    };
  }

    private async continueReorganizationFromRoute(
    newRoute: IRouteDetails,
    processingOptions?: IProcessingOptions,
  ) {
    const wizard = this.serviceWizardService;
    wizard.reorganizationRoutes[wizard.reorganizationIndex] = { ...newRoute };
    if (
      wizard.isLastReorganizationRoute &&
      !(await this.reviewReorganizationBookings(processingOptions))
    )
      return;
    this.returningToWizardServiceStep = true;
    try {
      this.onCloseDesignRoute();
    } finally {
      this.returningToWizardServiceStep = false;
    }
    if (!wizard.isLastReorganizationRoute) {
      wizard.restore(
        ServiceWizardStep.FORWARD_ROUTE,
        wizard.reorganizationIndex + 1,
      );
      wizard.canContinueEvaluator = () => this.isWizardRouteStepReady();
      this.router.navigate(wizard.reorganizationRoutePath(), {
        queryParams: this.activatedRoute.snapshot.queryParams,
      });
      await this.startWizardRouteStep();
      return;
    }
    wizard.restore(ServiceWizardStep.FORWARD_SETUP, 0);
    this.router.navigate(wizard.reorganizationSetupPath());
  }

  private get isLastWizardRouteStep(): boolean {
    if (this.serviceWizardService.reorganization)
      return this.serviceWizardService.isLastReorganizationRoute;
    return (
      this.serviceWizardService.step === ServiceWizardStep.BACKWARDS_ROUTE ||
      !this.serviceWizardService.roundTrip
    );
  }

  // Before leaving the map: the new routes are checked against the bookings of the source routes,
  // their max time is raised to cover every stop and the bookings they cannot serve are reviewed
  private async reviewReorganizationBookings(
    processingOptions?: IProcessingOptions,
  ): Promise<boolean> {
    const draft = this.routeReorganizationService.draft;
    if (!draft) return true;
    if (processingOptions) {
      draft.cancellationOptions = {
        refund: !!processingOptions.refund,
        fullRefund: !!processingOptions.fullRefund,
        cancelRelated: !!processingOptions.cancelRelated,
      };
      draft.sendNotification = processingOptions.sendNotification !== false;
      this.loadingSave = false;
      this.confirmChangesModal?.hide();
      return true;
    }
    this.openConfirmChangesModal(() => {
      this.confirmStep = 1;
      this.previewChanges = [];
      this.loadingRouteTimes = false;
    });
    this.confirmChangesTitle = this.literalService.get(
      'services.routes.reorganize.review.title',
      true,
    );
    this.confirmStep = 3;
    this.loadingRouteTimes = true;
    this.confirmChangesModal.show();
    try {
      const newRoutes = this.serviceWizardService.reorganizationRoutes;
      const simulation = await this.routeReorganizationService.simulate(
        draft.serviceInfoId,
        this.routeReorganizationService.buildRequest(
          { ...draft, assignments: [], cancellations: [] },
          newRoutes.map((route) =>
            this.routeReorganizationService.newRouteRequest(route, null),
          ),
        ),
      );
      this.applyReorganizationMaxTimes(newRoutes, simulation.newRoutes);
      draft.simulation = simulation;
      draft.cancellations =
        this.routeReorganizationService.incompatibleBookingIds(simulation);
      this.proposeReorganizationSetups(newRoutes);
      this.loadingRouteTimes = false;
      if (!draft.cancellations.length) {
        this.confirmChangesModal.hide();
        return true;
      }
      this.previewChanges = this.routeReorganizationService.previewChanges(
        draft,
        simulation,
      );
      this.confirmStep = 2;
      return false;
    } catch (error: any) {
      this.confirmChangesModal.hide();
      const errorCode = error?.error?.error_code;
      this.utilsService.showNotification(
        images.notifications.warning,
        errorCode ? `${errorCode}_ERROR` : 'services.routes.reorganize.error',
        NotificationTypes.DANGER,
      );
      return false;
    }
  }

  private applyReorganizationMaxTimes(
    newRoutes: any[],
    results: IRouteReorganizationNewRouteResult[],
  ) {
    const coverMaxTime = (result: IRouteReorganizationNewRouteResult) =>
      Math.max(result.requestedMaxTime, result.minutesToCoverEveryStop);
    const raised = results.filter(
      (result) =>
        coverMaxTime(result) > (newRoutes[result.newRouteIndex]?.maxTime ?? 0),
    );
    results.forEach((result) => {
      const newRoute = newRoutes[result.newRouteIndex];
      if (!newRoute) return;
      newRoute.maxTime = Math.max(newRoute.maxTime ?? 0, coverMaxTime(result));
      newRoute.minPathTime = result.minPathTime;
      newRoute.maxPathTime = result.minutesToCoverEveryStop;
    });
    const designedRoute =
      newRoutes[this.serviceWizardService.reorganizationIndex];
    if (designedRoute) this.onRouteMaxTimeRaised(designedRoute.maxTime);
    if (!raised.length) return;
    this.utilsService.showNotification(
      images.notifications.check,
      '',
      NotificationTypes.SUCCESS,
      this.literalService.get(
        'services.routes.reorganize.review.maxTimeRaised.title',
        true,
      ),
      raised
        .map((result) =>
          this.literalService.get(
            'services.routes.reorganize.review.maxTimeRaised.text',
            true,
            {
              route: newRoutes[result.newRouteIndex].name,
              minutes: newRoutes[result.newRouteIndex].maxTime,
            },
          ),
        )
        .join(' '),
      undefined,
      false,
    );
  }

  private proposeReorganizationSetups(newRoutes: any[]) {
    const draft = this.routeReorganizationService.draft!;
    const wizard = this.serviceWizardService;
    if (draft.setupsProposed) {
      const arrivalAnchor = this.routeReorganizationService.arrivesTogether(
        draft,
        newRoutes,
      );
      wizard.reorganizationSetups.forEach((setup, index) =>
        this.routeReorganizationService.stretchToMaxTime(
          setup,
          newRoutes[index].maxTime,
          arrivalAnchor,
        ),
      );
      return;
    }
    wizard.reorganizationSetups = this.routeReorganizationService.proposeSetups(
      draft,
      newRoutes.map((route) => ({
        maxTime: route.maxTime,
        terrain: route.terrain,
        secondsFromSourceStart:
          draft.type === RouteReorganizationType.SPLIT
            ? this.routeReorganizationService.secondsFromSourceStart(
                draft.sourceSchedules[0].route,
                route.terrain,
              )
            : 0,
      })),
      newRoutes.map((route) => route.name),
    );
    draft.setupsProposed = true;
  }

  // Service operations

  editServiceEvent() {
    this.editService = !this.editService;
  }

  async createService(newServiceObject: IServiceInfoDetail) {
    // Wizard: nothing is persisted per step — the service info is collected here, the route and
    // setup steps follow, and everything is created at the end with a single quick-creation call
    this.wizardServiceInfo = { ...newServiceObject };
    this.serviceWizardService.roundTrip = !!this.wizardServiceInfo.roundTrips;
    if (
      this.wizardRoute &&
      this.wizardRouteTownId !== (this.wizardServiceInfo.townId ?? null)
    ) {
      // The kept routes belong to a previously selected town: discard them
      this.wizardRoute = null;
      this.wizardBackwardsRoute = null;
      this.wizardRouteTownId = null;
    }
    if (!this.serviceWizardService.roundTrip) this.wizardBackwardsRoute = null;
    this.newService = false;
    this.newServiceObject = initialServiceInfoCreate();
    this.serviceWizardService.setStep(ServiceWizardStep.FORWARD_ROUTE);
    this.serviceWizardService.canContinueEvaluator = () =>
      this.isWizardRouteStepReady();
    if (!this.router.url.startsWith('/services/new/route')) {
      this.router.navigate(['/services', 'new', 'route'], {
        queryParams: this.activatedRoute.snapshot.queryParams,
      });
    }
    await this.startWizardRouteStep();
  }

  private async startWizardRouteStep() {
    const wizard = this.serviceWizardService;
    const backwards = wizard.step === ServiceWizardStep.BACKWARDS_ROUTE;
    const keptRoute = wizard.reorganization
      ? wizard.reorganizationRoutes[wizard.reorganizationIndex]
      : backwards
        ? this.wizardBackwardsRoute
        : this.wizardRoute;
    this.routeSelected = undefined;
    this.newRoute = true;
    this.showRoutes = true;
    const discretionary =
      this.wizardServiceInfo?.serviceType === ServiceType.DISCRETIONARY;
    await this.initEditMode(RouteEditMode.DESIGN, false, true);
    this.newRouteObject = keptRoute
      ? { ...keptRoute }
      : backwards
        ? this.buildBackwardsRouteFromForward()
        : initialRouteCreate();
    if (keptRoute?.terrain?.features?.length) {
      await this.redrawWizardRouteTerrain(keptRoute.terrain);
    } else if (keptRoute?.proposedStops?.length >= 2) {
      await this.applyRouteStops({
        stops: keptRoute.proposedStops,
        creationType: this.eventsOptions.creationSegmentsType,
      });
    } else if (backwards) {
      await this.seedBackwardsRouteFromForward();
    }
    // A reorganization keeps the type and the proposed path of its source routes
    if (this.serviceWizardService.reorganization) {
      // The type arrives already set, so the toolbar never sees it change and would not open the ordered stops
      if (this.hasOrderedStopsPanel(this.newRouteObject.expeditionType))
        await this.openRouteStopsModal();
    } else if (discretionary) {
      this.newRouteObject.expeditionType = ExpeditionType.Fixed;
      await this.openRouteStopsModal();
    }
    this.zoomToWizardTown();
  }

  private hasOrderedStopsPanel(expeditionType?: ExpeditionType): boolean {
    return (
      !!expeditionType &&
      expeditionType !== ExpeditionType[''] &&
      expeditionType !== ExpeditionType.HybridDoor2Door &&
      expeditionType !== ExpeditionType.DynamicDoor2Door
    );
  }

  private async captureWizardRouteFromMap() {
    // Going back to the service step: keep the drawn route so it can be redrawn if the
    // user continues again with the same town
    if (!this.map || this.routeDesign !== RouteEditMode.DESIGN) return;
    const terrain = this.utilsService.cleanTerrainObject(
      await this.readDesignTerrain(),
    );
    if (!terrain?.features?.length) return;
    const route = { ...this.newRouteObject, terrain };
    const wizard = this.serviceWizardService;
    if (wizard.reorganization)
      wizard.reorganizationRoutes[wizard.reorganizationIndex] = route;
    else if (wizard.step === ServiceWizardStep.BACKWARDS_ROUTE)
      this.wizardBackwardsRoute = route;
    else this.wizardRoute = route;
    this.wizardRouteTownId = this.wizardServiceInfo?.townId ?? null;
  }

  private buildBackwardsRouteFromForward(): any {
    // The backwards route starts from the forward attributes; name, geometry and time are its own
    const { name, terrain, outline, areas, maxTime, ...forwardAttributes } =
      this.wizardRoute ?? {};
    return { ...initialRouteCreate(), ...forwardAttributes };
  }

  private async seedBackwardsRouteFromForward() {
    const stops = this.utilsService
      .orderedTerrainStops(this.wizardRoute?.terrain)
      .reverse();
    if (stops.length < 2) return;
    await this.applyRouteStops({
      stops,
      creationType:
        this.wizardRouteCreationType ?? this.eventsOptions.creationSegmentsType,
    });
  }

  private async redrawWizardRouteTerrain(terrain: any) {
    // Returning from the setup step: the design map was cleared when the route was confirmed,
    // so the kept route terrain is loaded back into the map
    this.map.data.addGeoJson(terrain);
    await this.eventsOptions.loadSegmentAndStops(true, this.map);
    this.eventsOptions.removeDuplicatedTownStops();
    this.eventsOptions.demoteIsolatedRouteStops(this.demandStopsInRoute);
    this.eventsOptions.updateMarkers();
    // New features must keep decrementing below the redrawn ones to avoid id collisions
    const terrainFeatureIds = (terrain.features ?? [])
      .map((feature: any) => Number(feature.properties?.id))
      .filter((featureId: number) => !isNaN(featureId));
    const lowestTerrainFeatureId = Math.min(0, ...terrainFeatureIds);
    const townLatestFeatureId =
      this.editTownId > 0
        ? await this.townsService.getLatestFeatureId(this.editTownId)
        : 0;
    this.createOptions.setMinId(
      Math.min(
        lowestTerrainFeatureId,
        townLatestFeatureId,
        this.createOptions.minId,
      ),
    );
  }

  private zoomToWizardTown() {
    if (this.fitToTownStops(this.townStopsForFit)) return;
    const town = this.wizardTown;
    if (town?.latitude != null && town?.longitude != null) {
      this.map.setCenter({ lat: town.latitude, lng: town.longitude });
      this.map.setZoom(13);
    }
    setTimeout(() => this.fitToData(), 800);
  }

  get wizardTown(): any {
    return (
      this.wizardServiceInfo?.towns?.find(
        (town: any) => town.id == this.wizardServiceInfo.townId,
      ) ?? this.wizardServiceInfo?.towns?.[0]
    );
  }

  get wizardManagerClientName(): string | undefined {
    return this.wizardServiceInfo?.clients?.find(
      (client: any) => client.id == this.wizardServiceInfo.clientId,
    )?.name;
  }

  async updateService(serviceInfoDetail: IServiceInfoDetail) {
    this.editServiceEvent();
    try {
      this.serviceInfoSelected =
        await this.serviceInfoService.updateService(serviceInfoDetail);
      this.utilsService.showNotification(
        images.notifications.check,
        'services.actions.editService',
        NotificationTypes.SUCCESS,
      );
      this.hideOutlinesAndTerrains();
      this.filterByTowns();
    } catch {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.actions.editService',
        NotificationTypes.DANGER,
      );
    }
  }

  async deleteServiceEventEmitter(serviceId: number) {
    this.deleteServiceModal = new Modal(
      document.getElementById('deleteService'),
      {
        placement: 'center',
        closable: false,
        onHide: () => (this.deleteServiceShowed = false),
        onShow: () => (this.deleteServiceShowed = true),
      },
    );
    this.deleteServiceModal.toggle();
    this.serviceIdToDelete = serviceId;
  }

  async deleteServiceAction() {
    try {
      this.deletingService = true;
      this.deletionPercentage.set(0);
      const operationId = await this.serviceInfoService.deleteService(this.serviceIdToDelete!);
      await this.followDeletion(operationId);
      this.utilsService.showNotification(
        images.notifications.check,
        'services.actions.deleteService.success',
        NotificationTypes.SUCCESS,
      );
      this.closeServiceDetails();
      this.filterByTowns();
    } catch (error) {
      if (this.showDeletionBlockedByBookings(error)) return;
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.actions.deleteService.error',
        NotificationTypes.DANGER,
      );
    } finally {
      this.deletingService = false;
      this.resetDeletionProgress();
      this.deleteServiceModal.toggle();
      this.serviceIdToDelete = undefined;
    }
  }

  closeServiceDetails() {
    this.wizardServiceInfo = null;
    this.wizardRoute = null;
    this.wizardBackwardsRoute = null;
    this.wizardRouteTownId = null;
    this.serviceWizardService.stop();
    if (this.newService) {
      this.storageService.setTitleKey(null);
      this.newService = false;
      this.newServiceObject = initialServiceInfoCreate();
    } else {
      if (this.serviceInfoSelected || this.newRoute || this.routeDesign)
        this.closeRouteDetails();
      this.serviceInfoSelected = undefined;
      this.editService = false;
      this.showRoutes = false;
      this.routes = initialServicesState;
      this.showOutlinesAndTerrains();
    }

    this.updateUrlWithService();
    this.updateBreadcrumb();
  }

  // Route operations

  editRouteEvent() {
    this.editRoute = !this.editRoute;
    if (this.editRoute) this.originalRouteSelected = { ...this.routeSelected };
  }

  async addRoute() {
    this.routeSelected = undefined;
    this.newRoute = true;
    const discretionary =
      (this.serviceInfoSelected as any)?.serviceType ===
      ServiceType.DISCRETIONARY;
    await this.initEditMode(RouteEditMode.DESIGN, false, true);
    this.newRouteObject = initialRouteCreate();
    this.newRouteObject.serviceId = this.serviceInfoSelected!.id;
    if (discretionary) {
      this.newRouteObject.expeditionType = ExpeditionType.Fixed;
      await this.openRouteStopsModal();
    }
    this.updateUrlWithService(this.serviceInfoSelected?.id, true);
    this.updateBreadcrumb();
  }

  // Isolated stops go back to the town before the map is read, so the terrain only holds connected stops
  private readDesignTerrain(): Promise<any> {
    this.eventsOptions.demoteIsolatedRouteStops(this.demandStopsInRoute);
    return new Promise((resolve) => this.map.data.toGeoJson(resolve));
  }

  async createRoute(
    newRoute: IRouteDetails,
    processingOptions?: IProcessingOptions,
  ) {
    this.readDesignTerrain().then(async (geoJson: any) => {
      newRoute.terrain = this.utilsService.cleanTerrainObject(geoJson);
      newRoute.outline = this.utilsService.cleanOutlineObject(newRoute.outline);
      if (this.wizardServiceInfo) {
        // Wizard: keep the route locally; the quick-creation call persists everything at the end
        (newRoute as any).townStopsIncluded = this.townStopsIncluded;
        Object.assign(newRoute, await this.designedPathTimes());
        if (this.serviceWizardService.reorganization) {
          await this.continueReorganizationFromRoute(
            newRoute,
            processingOptions,
          );
          return;
        }
        const backwards =
          this.serviceWizardService.step === ServiceWizardStep.BACKWARDS_ROUTE;
        if (backwards) {
          this.wizardBackwardsRoute = { ...newRoute };
        } else {
          this.wizardRoute = { ...newRoute };
          this.wizardRouteCreationType =
            this.eventsOptions.creationSegmentsType;
        }
        this.wizardRouteTownId = this.wizardServiceInfo.townId ?? null;
        this.serviceWizardService.pendingQuickCreation = {
          serviceInfo: this.wizardServiceInfo,
          route: this.wizardRoute,
          backwardsRoute: this.wizardBackwardsRoute,
        };
        this.returningToWizardServiceStep = true;
        try {
          this.onCloseDesignRoute();
        } finally {
          this.returningToWizardServiceStep = false;
        }
        if (!backwards && this.serviceWizardService.roundTrip) {
          this.serviceWizardService.setStep(ServiceWizardStep.BACKWARDS_ROUTE);
          this.serviceWizardService.canContinueEvaluator = () =>
            this.isWizardRouteStepReady();
          this.router.navigate(this.serviceWizardService.routeStepPath(true), {
            queryParams: this.activatedRoute.snapshot.queryParams,
          });
          await this.startWizardRouteStep();
          return;
        }
        // The setup step happens on the setup screen: departures for discretionary services,
        // the standard days-of-week creation over a preloaded default setup otherwise
        this.serviceWizardService.setStep(ServiceWizardStep.FORWARD_SETUP);
        this.router.navigate(this.serviceWizardService.setupStepPath());
        return;
      }
      try {
        const route: any = await this.routeService.createRoute(
          newRoute,
          this.townStopsIncluded,
          processingOptions,
        );
        this.loadingSave = false;
        if (this.confirmChangesModalShowed) this.confirmChangesModal.hide();
        this.onCloseDesignRoute();
        this.utilsService.showNotification(
          images.notifications.check,
          'services.routes.actions.createRoute.success',
          NotificationTypes.SUCCESS,
        );
        // Leave the design mode into the route detail with the full DTO, like closing manually
        if (route?.id) await this.getRouteDetail(route.id);
        else this.routeSelected = route;
        this.getServices({});
      } catch (error: any) {
        this.loadingSave = false;
        if (this.confirmChangesModalShowed)
          this.confirmStep = this.previewChanges.length > 0 ? 2 : 1;
        const title = this.literalService.get(
          `${error.error_code}_ERROR.title`,
          true,
        );
        const text = this.buildRouteErrorText(error);
        this.utilsService.showNotification(
          images.notifications.warning,
          '',
          NotificationTypes.DANGER,
          title,
          text,
          undefined,
          false,
        );
      }
    });
  }

  async updateRoute(route: IRouteDetails) {
    if (route.maxTime! < this.originalRouteSelected?.maxTime) {
      this.onSave();
      return;
    }
    // Outside the design editor the map is only a viewer: the terrain to submit is the one received from the backend
    const readTerrain = (): Promise<any> =>
      new Promise((resolve) => {
        if (this.routeDesign === RouteEditMode.DESIGN && this.map)
          this.readDesignTerrain().then(resolve);
        else
          resolve(
            structuredClone(
              route.terrain ?? { type: 'FeatureCollection', features: [] },
            ),
          );
      });
    readTerrain().then(async (geoJson: any) => {
      const routePayload = this.buildRoutePayload(
        route,
        this.utilsService.cleanTerrainObject(geoJson),
      );
      this.showSavingModal();
      const resp: any = await this.routeService.updateRoute(
        routePayload,
        undefined,
        this.townStopsIncluded,
      );
      const onEditError = () => {
        this.utilsService.showNotification(
          images.notifications.warning,
          'services.routes.actions.editRoute.error',
          NotificationTypes.DANGER,
        );
        this.confirmChangesModal.hide();
      };
      this.connectAndHandleWebSocket(
        resp,
        async () => {
          this.utilsService.showNotification(
            images.notifications.check,
            'services.routes.actions.editRoute.success',
            NotificationTypes.SUCCESS,
          );
          this.editRoute = false;
          this.confirmChangesModal.hide();
          // The progress payload is a slim DTO: refetch the full detail so the form rebuild
          // does not run with missing data (e.g. /apps called with an undefined client)
          if (route.id)
            this.routeSelected = await this.routeService.getService(route.id);
        },
        onEditError,
        (error?: any) => this.onRouteRequestRejected(error, onEditError),
      );
    });
  }

  private openConfirmChangesModal(onHide: () => void) {
    this.confirmChangesModal = new Modal(document.getElementById('routeDesignConfirmChanges'), {
      placement: 'center',
      closable: false,
      onHide: () => {
        this.confirmChangesModalShowed = false;
        onHide();
      },
      onShow: () => (this.confirmChangesModalShowed = true),
    });
  }

  private showSavingModal() {
    this.confirmStep = 3;
    this.loadingSave = true;
    this.loadingPercentage = 0;
    this.confirmChangesTitle = this.literalService.get('services.routes.actions.updateRoute.title', true);
    this.openConfirmChangesModal(() => {
      this.loadingSave = false;
      this.confirmStep = 1;
    });
    this.confirmChangesModal.show();
  }

  async updateRouteDesign(updatedRoute: IRouteDetails, event: any) {
    const onFailed = (error?: any) => {
      if (error?.error_code) {
        const title = this.literalService.get(
          `${error.error_code}_ERROR.title`,
          true,
        );
        this.utilsService.showNotification(
          images.notifications.warning,
          '',
          NotificationTypes.DANGER,
          title,
          this.buildRouteErrorText(error),
          undefined,
          false,
        );
      } else {
        this.utilsService.showNotification(
          images.notifications.warning,
          'services.routes.actions.updateRoute.error',
          NotificationTypes.DANGER,
        );
      }
      this.loadingSave = false;
      this.confirmStep = this.previewChanges.length > 0 ? 2 : 1;
    };
    let resp: any;
    try {
      resp = await this.routeService.updateRoute(
        updatedRoute,
        event,
        this.townStopsIncluded,
      );
    } catch (error: any) {
      onFailed(error);
      return;
    }
    this.connectAndHandleWebSocket(
      resp,
      async (message: any) => {
        this.utilsService.showNotification(
          images.notifications.check,
          'services.routes.actions.updateRoute.success',
          NotificationTypes.SUCCESS,
        );
        this.mapHistoryService.clearHistory(this.routeSelected?.id ?? -1);
        this.confirmChangesModal.hide();
        this.loadingSave = false;
        if (this.editRoute) this.editRoute = false;
        // Committing leaves the design mode and shows the route detail, like closing it manually
        const committedRouteId =
          this.routeSelected?.id ??
          (objectToCamel(message.progress_entity_data) as any)?.id;
        this.onCloseDesignRoute();
        if (committedRouteId) await this.getRouteDetail(committedRouteId);
      },
      onFailed,
      onFailed,
    );
  }

  hideRoutes(routes: any[]) {
    this.showOutlinesAndTerrains(routes, this.routeSelected ? false : true);
  }

  async deleteRouteEventEmitter(routeId: number) {
    this.deleteRouteModal = new Modal(document.getElementById('deleteRoute'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.deleteRouteShowed = false),
      onShow: () => (this.deleteRouteShowed = true),
    });
    this.deleteRouteModal.toggle();
    this.routeIdToDelete = routeId;
  }

  showDuplicateRouteModal(route: IRouteDetails) {
    this.routeToDuplicate = route;
    this.duplicateRouteModal = new Modal(
      document.getElementById('duplicateRoute'),
      {
        placement: 'center',
        closable: !this.utilsService.isTouchDevice(),
        onHide: () => {
          this.duplicateRouteShowed = false;
          this.routeToDuplicate = undefined;
        },
        onShow: () => (this.duplicateRouteShowed = true),
      },
    );
    this.duplicateRouteModal.toggle();
  }

  async duplicateRouteAction(data: { name: string }) {
    try {
      this.duplicatingRoute = true;
      await this.routeService.duplicateRoute(
        this.routeToDuplicate!.id!,
        data.name,
      );
      this.utilsService.showNotification(
        images.notifications.check,
        'services.routes.actions.duplicateRoute.success',
        NotificationTypes.SUCCESS,
      );
      await this.getServices({ page: this.routes.pagination.actualPage });
    } catch {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.routes.actions.duplicateRoute.error',
        NotificationTypes.DANGER,
      );
    } finally {
      this.duplicatingRoute = false;
      this.duplicateRouteModal.hide();
    }
  }

  async deleteRouteAction() {
    try {
      this.deletingRoute = true;
      this.deletionPercentage.set(0);
      const operationId = await this.routeService.deleteRoute(this.routeIdToDelete!);
      await this.followDeletion(operationId);
      this.utilsService.showNotification(
        images.notifications.check,
        'services.routes.actions.deleteRoute.success',
        NotificationTypes.SUCCESS,
      );
      this.closeRouteDetails();
      await this.filterByTowns(undefined, true);
    } catch (error) {
      if (this.showDeletionBlockedByBookings(error)) return;
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.routes.actions.deleteRoute.error',
        NotificationTypes.DANGER,
      );
    } finally {
      this.deletingRoute = false;
      this.resetDeletionProgress();
      this.deleteRouteModal.toggle();
      this.routeIdToDelete = undefined;
    }
  }

  closeRouteDetails(closed?: boolean) {
    if (closed !== undefined) {
      this.routeDetailsClosed = closed;
    } else {
      this.routeSelected = undefined;
      this.editRoute = false;
      this.newRoute = false;
      this.onCloseDesignRoute();
      this.showOutlinesAndTerrains(undefined, true);

      if (this.serviceInfoSelected?.id) {
        this.updateUrlWithService(this.serviceInfoSelected.id, true);
      }
      this.updateBreadcrumb();
      if (this.wizardServiceInfo && !this.returningToWizardServiceStep) {
        this.backToWizardServiceStep();
      }
    }
  }

  closeRoutesModal() {
    if (!this.routeSelected) {
      this.showRoutes = false;
      this.routes = initialServicesState;
      this.serviceInfoSelected = undefined;
      this.updateUrlWithService();
      this.updateBreadcrumb();
    }
    this.showOutlinesAndTerrains(undefined, true);
    this.closeRouteDetails();
  }

  async showChangeStatus(event: { id: number; value: any }) {
    this.changeStatusSelected = event.value === 'activated';
    this.changeStatusRouteIdSelected = event.id;
    this.changeStatusModal = new Modal(
      document.getElementById('changeStatus'),
      {
        placement: 'center',
        closable: false,
        onHide: () => (this.changeStatusShowed = false),
        onShow: () => (this.changeStatusShowed = true),
      },
    );
    this.changeStatusModal.toggle();
  }

  async changeStatusAction() {
    this.changingStatus = true;
    const isActive = this.changeStatusSelected;
    const action = isActive ? 'activate' : 'deactivate';
    const successKey = `services.routes.actions.${action}.success`;
    const errorKey = `services.routes.actions.${action}.error`;

    try {
      const res = (await this.routeService[action](
        this.changeStatusRouteIdSelected,
      )) as IRouteDetails;
      this.routeSelected = res;
      this.utilsService.showNotification(
        images.notifications.check,
        successKey,
        NotificationTypes.SUCCESS,
      );
      this.getServices({});
    } catch (e: any) {
      const error = e?.error ?? e;
      if (error?.error_code === ErrorsCode.STOPS_MISSING_FROM_TOWN) {
        const title = this.literalService.get(
          `${error.error_code}_ERROR.title`,
          true,
        );
        this.utilsService.showNotification(
          images.notifications.warning,
          '',
          NotificationTypes.DANGER,
          title,
          this.buildRouteErrorText(error),
          undefined,
          false,
        );
      } else {
        this.utilsService.showNotification(
          images.notifications.warning,
          errorKey,
          NotificationTypes.DANGER,
        );
      }
    } finally {
      this.changeStatusModal.toggle();
      this.changingStatus = false;
    }
  }

  getModalTexts(type: string) {
    if (type === 'text') {
      return `services.routes.actions.${this.changeStatusSelected ? 'activate' : 'deactivate'}.description`;
    } else {
      return `services.routes.actions.${this.changeStatusSelected ? 'activate' : 'deactivate'}.title`;
    }
  }

  // Multi-config operations

  openReorganization() {
    this.routeReorganizationService.returnUrl = this.router.url;
    this.router.navigate([
      '/services',
      this.serviceInfoSelected!.id,
      'reorganize',
    ]);
  }

  openMultiConfig() {
    this.closeRouteDetails();
    this.multiConfigObject = initialPartialRouteSetupConfig();
    this.showMultiConfig = true;
    this.editMultiConfig = true;
  }

  closeMultiConfig() {
    this.showMultiConfig = false;
    this.editMultiConfig = true;
    this.multiConfigObject = initialPartialRouteSetupConfig();
  }

  handleMultiConfigSubmit(event: any) {
    if (event.type === 'create') {
      const configData = this.buildPartialConfig(event.value);
      this.pendingMultiConfigData = configData;
      this.multiConfigConfirmModal = new Modal(
        document.getElementById('multiConfigConfirm'),
        {
          placement: 'center',
          closable: false,
          onHide: () => (this.multiConfigConfirmShowed = false),
          onShow: () => (this.multiConfigConfirmShowed = true),
        },
      );
      this.multiConfigConfirmModal.show();
    }
  }

  private buildPartialConfig(data: any): any {
    const config: any = {};
    if (data.fromDate) config.fromDate = data.fromDate;
    if (data.toDate) config.toDate = data.toDate;

    if (data.config) {
      Object.keys(data.config).forEach((key) => {
        const value = data.config[key];
        if (value !== null && value !== undefined && value !== '') {
          config[key] = value;
        }
      });
    }

    return config;
  }

  async onConfirmMultiConfigUpdate(options: MultiConfigUpdateOptions) {
    if (!this.serviceInfoSelected?.id || !this.pendingMultiConfigData) return;

    this.updatingMultiConfig = true;

    try {
      await this.serviceInfoService.updateSetupsConfig(
        this.serviceInfoSelected!.id!,
        this.pendingMultiConfigData,
        {
          deleteAvailabilities: options.deleteAvailabilities,
          deleteComment: options.deleteComment || undefined,
          sendNotification: options.sendNotification,
          refund: options.refund,
          cancelRelated: options.cancelRelated,
          fullRefund: options.fullRefund,
        },
      );

      this.utilsService.showNotification(
        images.notifications.check,
        'services.routes.multiConfig.success',
        NotificationTypes.SUCCESS,
      );
      this.multiConfigConfirmModal.hide();
      this.closeMultiConfig();
    } catch {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.routes.multiConfig.error',
        NotificationTypes.DANGER,
      );
    } finally {
      this.updatingMultiConfig = false;
      this.pendingMultiConfigData = null;
    }
  }

  private get editTownId(): number {
    return (
      this.routeSelected?.town?.id ??
      this.serviceInfoSelected?.town?.id ??
      this.serviceInfoSelected?.towns?.[0]?.id ??
      this.wizardServiceInfo?.townId
    );
  }

  // The details form needs a town and a manager client even for a route that does not exist yet.
  // The routes list is empty while creating the first route of a service, so it is only the last resort
  public get detailsTown(): ITown | undefined {
    if (this.wizardServiceInfo) return this.wizardTown;
    return (
      this.routeSelected?.town ??
      this.serviceInfoSelected?.town ??
      this.serviceInfoSelected?.towns?.[0] ??
      this.routes?.value?.[0]?.town
    );
  }

  public get detailsManagerClientName(): string | undefined {
    if (this.wizardServiceInfo) return this.wizardManagerClientName;
    return (
      this.routeSelected?.managerClient?.name ??
      this.serviceInfoSelected?.managerClient?.name ??
      this.routes?.value?.[0]?.managerClientName
    );
  }

  // The town stop catalogue is scoped to the route's manager client, the same one the backend reconciles
  // against on save. The route being designed does not exist yet, so it is resolved the way the route form
  // does: by the manager client name the details form is built with
  get editManagerClientId(): number | undefined {
    if (this.wizardServiceInfo?.clientId)
      return this.wizardServiceInfo.clientId;
    const managerClientName = this.detailsManagerClientName;
    return this.clients?.find(
      (client: IClient) => client.name === managerClientName,
    )?.id;
  }

  async openRouteDesign(routeId: number) {
    if (this.routeSelected?.id !== routeId)
      await this.getRouteDetail(routeId, true);
    await this.initEditMode();
  }

  async initEditMode(
    mode: RouteEditMode = RouteEditMode.DESIGN,
    closedDetails?: boolean,
    skipUrlUpdate?: boolean,
  ) {
    // The panel state is settled before anything is fetched: the town catalogue is a heavy request,
    // and leaving the details form open (or half set up) while it travels is what the user sees
    this.routeDesign = mode;
    this.routeDetailsClosed = closedDetails ?? true;
    this.routeDetailsWidth = this.newRoute ? 408 : 32;
    this.eventsOptions.setTownStopsCreateOnly(
      mode === RouteEditMode.ALTERATIONS || !!this.wizardServiceInfo,
    );
    if (mode !== RouteEditMode.ALTERATIONS) this.resetAlterationState();
    this.hideOutlinesAndTerrains();
    if (localStorage.getItem(APP.LOCAL_STORAGE_HIDE_SHARED_STOP_ALERT))
      localStorage.removeItem(APP.LOCAL_STORAGE_HIDE_SHARED_STOP_ALERT);
    if (mode === RouteEditMode.ALTERATIONS) {
      this.requestedAlterationId = parseId(
        this.activatedRoute.snapshot.queryParamMap.get('alteration'),
      );
      await this.loadAlterations();
    }
    if (mode === RouteEditMode.DESIGN) await this.refreshOrderedStopsContext();
    // TODO: uncomment when route status is done
    // else if (!this.newRoute) await this.loadRouteVersions();
    // A failed fetch must not leave the editor without its map events and controls
    try {
      await this.initRouteMap();
    } catch (error) {
      console.error('Error initialising the route map:', error);
    }
    if (
      mode === RouteEditMode.DESIGN &&
      !this.newRoute &&
      this.hasOrderedStopsPanel(this.routeSelected?.expeditionType)
    )
      this.orderedStopsOpenRequest++;
    this.eventsOptions.attachDataLayerEvents(
      this.map,
      this.editTownId,
      this.routeSelected?.id,
    );
    this.map.setOptions({
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      fullscreenControl: false,
      cameraControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      rotateControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      draggableCursor: `url(${images.cursor.default}), auto`,
      draggingCursor: `url(${images.cursor.drag}), move`,
    });
    this.map.getStreetView().setOptions({
      disableDefaultUI: true,
      addressControl: true,
      addressControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      fullscreenControl: false,
      panControl: true,
      panControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
    });
    this.renderFullScreenButton();
    if (!skipUrlUpdate) {
      this.updateUrlWithService(
        this.serviceInfoSelected?.id,
        true,
        this.routeSelected?.id,
        mode,
      );
      this.updateBreadcrumb();
    }
  }

  onCloseDesignRoute() {
    if (
      this.serviceWizardService.reorganization &&
      this.wizardServiceInfo &&
      this.routeDesign === RouteEditMode.DESIGN &&
      !this.returningToWizardServiceStep
    ) {
      // Leaving the map of a reorganization goes back one wizard step instead of to the service creation
      this.onWizardBack();
      return;
    }
    const wasDesigning = !!this.routeDesign || this.newRoute;
    if (this.newRoute) this.closeRouteDetails();
    this.routeDesign = null;
    this.routeDesignDetail = null;
    this.routeDraft = null;
    this.routeScheduled = null;
    this.selectedRouteStatus = RouteStatus.ACTIVE;
    this.routeDetailsClosed = false;
    if (wasDesigning) this.eventsOptions.clearMap();
    this.eventsOptions.detachDataLayerEvents();
    this.map.setOptions({
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      fullscreenControl: true,
      cameraControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      rotateControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
    });
    if (this.map.getStreetView().getVisible()) {
      this.map.getStreetView().setVisible(false);
    }
    this._cleanupFullscreen?.();
    this._cleanupFullscreen = null;
    this.showOutlinesAndTerrains();
    this.updateUrlWithService(
      this.serviceInfoSelected?.id,
      true,
      this.routeSelected?.id,
    );
  }

  ngOnDestroy(): void {
    this.storageService.clearBreadcrumb();
    this.queryParamsSub?.unsubscribe();
    this.paramsSub?.unsubscribe();
    this.wizardContinueSubscription?.unsubscribe();
    this.wizardBackSubscription?.unsubscribe();
    this.serviceWizardService.stop();
  }

  private applyTownsFromUrl(urlTownsRaw: string): void {
    const currentKey = this.selectedTowns
      .map((t) => t.id)
      .sort()
      .join(',');
    const ids = urlTownsRaw
      ? urlTownsRaw
          .split(',')
          .map(Number)
          .filter((n) => !isNaN(n))
      : [];
    const incomingKey = [...ids].sort().join(',');
    if (currentKey === incomingKey) return;

    this.selectedTowns = ids
      .map((id) => this.towns.find((t) => t.id === id))
      .filter((t): t is ITown => t != null);
    this.refreshServicesForSelection();
  }

  async onSave(event?: any) {
    if (this.loadingRouteTimes) return;
    // Creating only needs the confirm modal when the town catalogue travels with the route: its
    // stop changes are the only thing that can rebuild expeditions, and only of the other routes
    if (this.newRoute && (this.wizardServiceInfo || !this.townStopsIncluded)) {
      this.createRoute(this.newRouteObject);
      return;
    }
    const isDesign = this.routeDesign === RouteEditMode.DESIGN;
    const action: RouteSaveAction =
      !this.newRoute && isDesign && typeof event === 'string'
        ? (event as RouteSaveAction)
        : RouteSaveAction.UPDATE;
    this.saveAction = action;
    if (typeof event === 'string') event = undefined;
    if (action === RouteSaveAction.DRAFT) {
      await this.saveRouteDraft();
      return;
    }
    const route = this.newRoute ? this.newRouteObject : this.routeSelected;
    this.openConfirmChangesModal(() => {
      this.confirmStep = 1;
      this.previewChanges = [];
      this.loadingPreview = false;
      this.previewOperationId = undefined;
      this.loadingRouteTimes = false;
      this.scheduleDateTime = null;
      this.saveAction = RouteSaveAction.UPDATE;
    });
    if (this.map && route) {
      this.confirmStep = 3;
      this.loadingRouteTimes = true;
      this.confirmChangesTitle = this.literalService.get(
        'services.routes.design.times.loading.title',
        true,
      );
      this.confirmChangesModal.show();
      const graphRequest = this.eventsOptions.buildRouteGraphRequest();
      this.routeTimes = graphRequest
        ? routeTimesOf(await this.routeGraphService.computePaths(graphRequest))
        : null;
      this.loadingRouteTimes = false;
      if (!this.confirmChangesModalShowed) return;
      const maxTimeSeconds = route.maxTime! * 60;
      if ((this.routeTimes?.minPathTime || 0) >= maxTimeSeconds) {
        this.confirmChangesModal.hide();
        this.showMaxTimeExceededModal();
        return;
      }
      if (this.coverageExceedsMaxTime(route, maxTimeSeconds)) {
        this.pendingSaveAfterCoverageConfirmation = { event, action };
        this.confirmChangesModal.hide();
        this.showCoverageExceedsMaxTimeModal();
        return;
      }
    }
    this.confirmStep = action === RouteSaveAction.SCHEDULE ? 0 : 1;
    if (this.routeDesign === RouteEditMode.ALTERATIONS) {
      this.confirmChangesTitle = this.literalService.get(
        'alterations.actions.update.title',
        true,
      );
      if (this.deletingAlteration)
        this.confirmChangesTitle = this.literalService.get(
          'alterations.actions.delete.title',
          true,
        );
      if (this.newAlteration || this.isDuplicatingAlteration) {
        if (event !== undefined) this.newAlterationObject = event;
        this.confirmChangesTitle = this.literalService.get(
          'alterations.actions.create.title',
          true,
        );
      } else if (event !== undefined) {
        this.selectedAlteration = event;
        this.confirmChangesTitle = this.literalService.get(
          'alterations.actions.update.title',
          true,
        );
      }
      const alteration =
        this.newAlteration || this.isDuplicatingAlteration
          ? this.newAlterationObject
          : this.selectedAlteration;
      if (!alteration?.active) {
        const updateOptions: IProcessingOptions = {
          rebuild: false,
          rebuildStatus: [],
          sendNotification: false,
          refund: false,
          fullRefund: false,
          cancelRelated: false,
          skipTripsIds: [],
        };
        this.confirmChangesModal.show();
        this.onConfirmChanges(updateOptions);
        return;
      }
    } else if (action === RouteSaveAction.SCHEDULE) {
      this.confirmChangesTitle = this.literalService.get(
        'services.routes.actions.scheduleUpdate.title',
        true,
      );
    } else if (this.newRoute) {
      this.confirmChangesTitle = this.literalService.get(
        'services.routes.actions.createRoute.title',
        true,
      );
    } else {
      this.confirmChangesTitle = this.literalService.get(
        'services.routes.actions.updateRoute.title',
        true,
      );
    }
    this.confirmChangesModal.show();
  }

  async saveRouteDraft() {
    const routeId = this.routeSelected?.id;
    if (!routeId || !this.map) return;
    this.map.data.toGeoJson(async (json: any) => {
      try {
        const terrain = this.utilsService.cleanTerrainObject(json);
        await this.routeService.saveRouteDraftTerrain(routeId, { terrain });
        await this.loadRouteVersions();
        this.utilsService.showNotification(
          images.notifications.check,
          'services.routes.actions.saveDraft.success',
          NotificationTypes.SUCCESS,
        );
      } catch {
        this.utilsService.showNotification(
          images.notifications.warning,
          'services.routes.actions.saveDraft.error',
          NotificationTypes.DANGER,
        );
      }
    });
  }

  showMaxTimeExceededModal() {
    this.maxTimeExceededModal = new Modal(
      document.getElementById('maxTimeExceededAlert'),
      {
        placement: 'center',
        closable: false,
        onHide: () => (this.maxTimeExceededModalShowed = false),
        onShow: () => (this.maxTimeExceededModalShowed = true),
      },
    );
    this.maxTimeExceededModal.toggle();
  }

  hideMaxTimeExceededModal() {
    this.maxTimeExceededModal.hide();
  }

  private coverageExceedsMaxTime(route: any, maxTimeSeconds: number): boolean {
    if (
      route.expeditionType === ExpeditionType.Fixed ||
      this.coverageExceedsMaxTimeAccepted
    )
      return false;
    return (this.routeTimes?.maxPathTime ?? 0) > maxTimeSeconds;
  }

  showCoverageExceedsMaxTimeModal() {
    this.coverageExceedsMaxTimeModal = new Modal(
      document.getElementById('coverageExceedsMaxTimeAlert'),
      {
        placement: 'center',
        closable: !this.utilsService.isTouchDevice(),
        onHide: () => (this.coverageExceedsMaxTimeModalShowed = false),
        onShow: () => (this.coverageExceedsMaxTimeModalShowed = true),
      },
    );
    this.coverageExceedsMaxTimeModal.toggle();
  }

  async confirmCoverageExceedsMaxTime() {
    this.coverageExceedsMaxTimeModal.hide();
    const pending = this.pendingSaveAfterCoverageConfirmation;
    this.pendingSaveAfterCoverageConfirmation = null;
    if (!pending) return;
    this.coverageExceedsMaxTimeAccepted = true;
    try {
      await this.onSave(pending.event ?? pending.action);
    } finally {
      this.coverageExceedsMaxTimeAccepted = false;
    }
  }

  getCoverageExceedsMaxTimeText() {
    const route = this.newRoute ? this.newRouteObject : this.routeSelected;
    return this.literalService.get(
      'services.routes.design.actions.update.coverageExceedsMaxTime.description',
      true,
      {
        coverageTime: this.utilsService.formatSecondsAsTime(
          this.routeTimes?.maxPathTime,
        ),
        maxTime: `${route?.maxTime} min`,
      },
    );
  }

  getMaxTimeExceededText() {
    const route = this.newRoute ? this.newRouteObject : this.routeSelected;
    return this.literalService.get(
      'services.routes.design.actions.update.maxTimeExceeded.description',
      true,
      {
        minTime: this.utilsService.formatSecondsAsTime(
          this.routeTimes?.minPathTime,
        ),
        maxTime: `${route?.maxTime} min`,
      },
    );
  }

  onDeleteAlteration() {
    this.deletingAlteration = true;
    this.onSave();
  }

  onCancelSave() {
    if (this.serviceWizardService.reorganization && this.confirmStep === 2) {
      this.confirmChangesModal.hide();
    } else if (this.confirmStep === 2) {
      this.previewChanges = [];
      this.confirmStep = 1;
    } else if (
      this.confirmStep === 1 &&
      this.saveAction === RouteSaveAction.SCHEDULE
    ) {
      this.confirmStep = 0;
    } else {
      this.confirmChangesModal.hide();
      if (this.deletingAlteration) this.deletingAlteration = false;
    }
  }

  onConfirmChanges(event: any) {
    if (this.confirmStep === 0) {
      this.scheduleDateTime = event.dateTime;
      this.confirmStep = 1;
      return;
    }
    if (event.showPreview) {
      this.confirmStep = 2;
      this.getPreview(event.rebuildStatus);
    } else {
      this.confirmStep = 3;
      this.loadingSave = true;
      this.loadingPercentage = 0;
      this.phaseStatus = PhaseStatus.IN_PROGRESS;
      const readTerrain =
        this.routeDesign === RouteEditMode.DESIGN
          ? this.readDesignTerrain()
          : new Promise((resolve) => this.map.data.toGeoJson(resolve));
      readTerrain.then(async (json: any) => {
        const cleanTerrain = this.utilsService.cleanTerrainObject(json);
        try {
          if (this.routeDesign === RouteEditMode.ALTERATIONS) {
            if (this.newAlteration || this.isDuplicatingAlteration) {
              this.createAlteration(
                { ...this.newAlterationObject, terrain: cleanTerrain },
                event,
              );
            } else {
              if (this.deletingAlteration)
                this.deleteAlteration(this.selectedAlteration!, event);
              else
                this.updateAlteration(
                  { ...this.selectedAlteration!, terrain: cleanTerrain },
                  event,
                );
            }
          } else if (this.newRoute) {
            this.createRoute(this.newRouteObject, event);
          } else if (this.saveAction === RouteSaveAction.SCHEDULE) {
            this.scheduleRouteUpdate(cleanTerrain, event);
          } else {
            this.updateRouteDesign(
              this.buildRoutePayload(this.routeSelected, cleanTerrain),
              event,
            );
          }
        } catch (e: any) {
          this.confirmStep = 1;
          this.loadingSave = false;
        }
      });
    }
  }

  async scheduleRouteUpdate(
    terrain: any,
    processingOptions: IProcessingOptions,
  ) {
    const routeId = this.routeSelected?.id;
    if (!routeId || !this.scheduleDateTime) return;
    try {
      await this.routeService.scheduleRouteTerrainUpdate(
        routeId,
        { terrain, dateTime: this.scheduleDateTime },
        processingOptions,
      );
      await this.loadRouteVersions();
      this.utilsService.showNotification(
        images.notifications.check,
        'services.routes.actions.scheduleUpdate.success',
        NotificationTypes.SUCCESS,
      );
      this.loadingSave = false;
      this.confirmChangesModal.hide();
    } catch {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.routes.actions.scheduleUpdate.error',
        NotificationTypes.DANGER,
      );
      this.loadingSave = false;
      this.confirmStep = this.previewChanges.length > 0 ? 2 : 1;
    }
  }

  private async connectAndHandleWebSocket(
    resp: any,
    onCompleted: (message: any) => void,
    onError: () => void,
    onFailed?: (error?: any) => void,
  ): Promise<void> {
    const ephemeralToken =
      (await this.authService.getEphemeralToken()) as string;
    this.webSocketService.connect(resp, ephemeralToken);
    let outcomeReceived = false;
    this.webSocketService.getMessages().subscribe({
      next: (message: any) => {
        this.loadingPercentage = message.total_percentage;
        if (this.webSocketService.isIntermediatePhaseCompletion(message)) return;
        this.phaseStatus = message.phase_status;
        this.updateLoadingDetail(message);
        if (
          this.phaseStatus === PhaseStatus.COMPLETED &&
          !this.webSocketService.isOperationCompleted(message)
        )
          return;
        switch (this.phaseStatus) {
          case PhaseStatus.COMPLETED:
            outcomeReceived = true;
            onCompleted(message);
            break;
          case PhaseStatus.FAILED: {
            outcomeReceived = true;
            const error = this.utilsService.isJSON(message.progress_entity_data) ? JSON.parse(message.progress_entity_data) : undefined;
            if (onFailed) {
              onFailed(error);
            } else if (error) {
              const title = this.literalService.get(`${error.error_code}_ERROR.title`, true);
              const text = this.buildRouteErrorText(error);
              this.utilsService.showNotification(
                images.notifications.warning,
                '',
                NotificationTypes.DANGER,
                title,
                text,
                undefined,
                false,
              );
              onError();
              throw new Error(error.error_code);
            } else {
              onError();
            }
            break;
          }
        }
      },
      error: onError,
      // The backend closes the socket cleanly on failure, so a stream that ends without an
      // outcome would otherwise leave the caller's loading state spinning forever
      complete: () => {
        if (!outcomeReceived) onError();
      }
    });
  }

  async getPreview(rebuildStatus?: string[]) {
    this.confirmStep = 3;
    this.loadingPreview = true;
    this.loadingDetail = '';
    this.loadingPercentage = 0;
    this.phaseStatus = PhaseStatus.IN_PROGRESS;
    this.previewOperationId = undefined;
    const readTerrain =
      this.routeDesign === RouteEditMode.DESIGN
        ? this.readDesignTerrain()
        : new Promise((resolve) => this.map.data.toGeoJson(resolve));
    readTerrain.then(async (json: any) => {
      let operationId: string | undefined;
      try {
        const cleanTerrain = this.utilsService.cleanTerrainObject(json);
        if (this.routeDesign === RouteEditMode.DESIGN) {
          const baseRoute = structuredClone(
            this.newRoute ? this.newRouteObject : this.routeSelected,
          );
          const previewRoute = this.buildRoutePayload(baseRoute, cleanTerrain);
          operationId = await this.routeService.getRoutePreview(
            previewRoute,
            rebuildStatus,
            this.townStopsIncluded,
          );
        } else if (this.routeDesign === RouteEditMode.ALTERATIONS) {
          const previewAlteration = structuredClone(
            this.newAlteration
              ? this.newAlterationObject
              : this.selectedAlteration!,
          );
          previewAlteration.terrain = cleanTerrain;
          operationId = await this.routeService.getAlterationPreview(
            this.routeSelected.id,
            previewAlteration,
            rebuildStatus,
            this.deletingAlteration,
          );
        }
      } catch (error: any) {
        this.onPreviewFailed(error, false);
        return;
      }
      if (!operationId || !this.loadingPreview) return;
      this.previewOperationId = operationId;
      const isCurrentPreview = () => this.previewOperationId === operationId;
      await this.connectAndHandleWebSocket(
        operationId,
        (message: any) => {
          if (!isCurrentPreview()) return;
          const routePreviewChanges = this.routeService.toRoutePreviewChanges(
            message.progress_entity_data,
          );
          this.previewChanges = this.buildPreviewChanges(routePreviewChanges);
          this.confirmStep = 2;
          this.loadingPreview = false;
        },
        () => {
          if (isCurrentPreview()) this.onPreviewFailed();
        },
        (error?: any) => {
          if (isCurrentPreview()) this.onPreviewFailed(error);
        },
      );
    });
  }

  private buildPreviewChanges(changes: any[]): IRoutePreview[] {
    const currentRouteId = this.routeSelected?.id;
    const currentRouteFirst = [...changes].sort((first, second) => {
      if (first.route?.id === currentRouteId) return -1;
      if (second.route?.id === currentRouteId) return 1;
      return 0;
    });
    return currentRouteFirst.map((routeChanges) => ({
      ticketing: routeChanges.ticketing,
      roundTrip: routeChanges.roundTrip,
      route: routeChanges.route,
      bookings: [
        ...(routeChanges.bookingsToCancel ?? []).map((booking: any) => ({
          ...booking.booking,
          toCancel: true,
          reason: booking.reason,
        })),
        ...(routeChanges.bookingsToRedo ?? []).map((booking: any) => ({
          ...booking.booking,
          toRedo: true,
          reason: booking.reason,
        })),
      ].sort(
        (first, second) =>
          new Date(first.date).getTime() - new Date(second.date).getTime(),
      ),
    }));
  }

  private onPreviewFailed(error?: any, notifySocketFailure = true) {
    this.previewOperationId = undefined;
    this.previewChanges = [];
    this.confirmStep = 1;
    this.loadingPreview = false;
    if (error?.error_code === ErrorsCode.ALTERATION_OVERLAP) {
      this.onRouteRequestRejected(error, () => {});
    } else if (!notifySocketFailure) {
      return;
    } else if (error?.error_code) {
      const title = this.literalService.get(`${error.error_code}_ERROR.title`, true);
      this.utilsService.showNotification(
        images.notifications.warning,
        '',
        NotificationTypes.DANGER,
        title,
        this.buildRouteErrorText(error),
        undefined,
        false,
      );
    } else {
      this.utilsService.showNotification(
        images.notifications.warning,
        'services.routes.design.update.review.loading.error',
        NotificationTypes.DANGER,
      );
    }
  }

  get confirmChangesModalTitle(): string {
    const previewingRouteUpdate = this.loadingPreview && this.routeDesign === RouteEditMode.DESIGN && !this.newRoute;
    if (!previewingRouteUpdate) return this.confirmChangesTitle;
    return this.literalService.get('services.routes.actions.updateRoute.previewTitle', true);
  }

  get confirmChangesLoadingTitle(): string {
    if (this.loadingRouteTimes) return 'services.routes.design.times.loading.title';
    if (this.loadingPreview) return 'services.routes.design.update.review.loading.title';
    return 'services.routes.design.update.loading.title';
  }

  renderFullScreenButton() {
    if (this._cleanupFullscreen) this._cleanupFullscreen();
    this._cleanupFullscreen = this.mapUtilsService.setupFullscreenButton(
      this.map,
      google.maps.ControlPosition.LEFT_TOP,
      {
        marginTop:
          this.routeDesign === RouteEditMode.DESIGN || this.newAlteration
            ? '80px'
            : '134px',
      },
    );
  }

  // ALTERATIONS
  isRouteValidForSave() {
    return this.routeDetails?.isFormValid() ?? false;
  }

  isRouteModified() {
    return this.routeDetails?.routeModified ?? false;
  }

  isAlterationValidForPreview() {
    const a = this.newAlteration
      ? this.newAlterationObject
      : this.selectedAlteration;
    return !!a?.startDateTime && !!a?.endDateTime;
  }

  private isAlterationValidForSave() {
    return this.alterationDetails?.isFormValid() ?? false;
  }

  alterationSaveDisabled() {
    return (
      !this.isAlterationValidForSave() || !this.isAlterationValidForPreview()
    );
  }

  isAlterationModified() {
    if (
      this.newAlteration ||
      !this.selectedAlteration ||
      !this.originalAlteration
    )
      return false;
    return this.alterationFields(this.selectedAlteration) !== this.alterationFields(this.originalAlteration);
  }

  private alterationFields(alteration: IRouteAlteration): string {
    return JSON.stringify({
      name: alteration.name ?? '',
      startDateTime: alteration.startDateTime ?? null,
      endDateTime: alteration.endDateTime ?? null,
      informativeMessage: alteration.informativeMessage ?? '',
      active: alteration.active ?? null,
    });
  }

  async loadRouteVersions() {
    const routeId = this.routeSelected?.id;
    if (!routeId) return;
    const [draft, scheduled] = await Promise.allSettled([
      this.routeService.getRouteDraftTerrain(routeId),
      this.routeService.getRouteScheduledChange(routeId),
    ]);
    this.routeDraft = draft.status === 'fulfilled' ? draft.value : null;
    this.routeScheduled =
      scheduled.status === 'fulfilled' ? scheduled.value : null;
  }

  async onChangeRouteStatus(status: RouteStatus) {
    if (status === this.selectedRouteStatus) return;
    const generation = ++this.routeVersionLoadGeneration;
    this.selectedRouteStatus = status;
    this.mapHistoryService.clearHistory(this.routeSelected?.id ?? -1);
    this.eventsOptions.detachDataLayerEvents();
    await this.initRouteMap();
    if (generation !== this.routeVersionLoadGeneration) return;
    this.eventsOptions.attachDataLayerEvents(
      this.map,
      this.editTownId,
      this.routeSelected?.id,
    );
  }

  private resetAlterationState(): void {
    this.alterations = [];
    this.selectedAlteration = undefined;
    this.originalAlteration = undefined;
    this.newAlterationObject = initialRouteAlterationCreate();
    this.newAlteration = false;
    this.editAlteration = false;
    this.alterationChanged = false;
    this.alterationDetailsClosed = true;
    this.isDuplicatingAlteration = false;
    this.deletingAlteration = false;
  }

  async loadAlterations() {
    this.alterations = (await this.routeService.getRouteAlterations(
      this.routeSelected.id,
    )) as IRouteAlteration[];
  }

  async onChangeAlteration(alteration: IRouteAlteration) {
    const generation = ++this.alterationLoadGeneration;
    this.newAlteration = false;
    this.renderFullScreenButton();
    if (alteration) {
      const alterationDetail = await this.routeService.getAlteration(
        this.routeSelected.id,
        alteration.id!,
      );
      if (generation !== this.alterationLoadGeneration) return;
      this.selectedAlteration = alterationDetail;
      await this.initRouteMap();
      this.eventsOptions.attachDataLayerEvents(
        this.map,
        this.editTownId,
        this.routeSelected?.id,
      );
    } else {
      this.selectedAlteration = undefined;
    }
  }

  async onNewAlteration() {
    this.newAlterationObject = initialRouteAlterationCreate();
    this.newAlterationBaseline = this.alterationFields(this.newAlterationObject);
    this.newAlterationObject.terrain = Object.assign(
      [],
      this.routeSelected.terrain,
    );
    this.newAlteration = true;
    this.renderFullScreenButton();
    this.alterationDetailsClosed = false;
    await this.initRouteMap();
    this.eventsOptions.attachDataLayerEvents(
      this.map,
      this.editTownId,
      this.routeSelected?.id,
    );
  }

  onEditAlteration() {
    if (!this.editAlteration) {
      this.originalAlteration = structuredClone(this.selectedAlteration);
    } else {
      this.selectedAlteration = this.originalAlteration;
      this.originalAlteration = undefined;
    }
    this.editAlteration = !this.editAlteration;
  }

  onViewAlterationDetail() {
    this.alterationDetailsClosed = false;
  }

  async onCloseAlteration(closed: boolean | undefined) {
    if (closed === undefined) {
      this.newAlteration = false;
      this.isDuplicatingAlteration = false;
      this.renderFullScreenButton();
      this.alterationDetailsClosed = true;
      await this.initRouteMap();
      this.eventsOptions.attachDataLayerEvents(
        this.map,
        this.editTownId,
        this.routeSelected?.id,
      );
    } else {
      this.alterationDetailsClosed = closed;
    }
  }

  async createAlteration(
    newAlteration: IRouteAlteration,
    processingOptions: IProcessingOptions,
  ) {
    this.map.data.toGeoJson(async (json: any) => {
      const cleanTerrain = this.utilsService.cleanTerrainObject(json);
      newAlteration.terrain = cleanTerrain;
      const onError = () => {
        this.utilsService.showNotification(
          images.notifications.warning,
          `alterations.actions.create.error`,
          NotificationTypes.DANGER,
        );
        this.loadingSave = false;
      };
      let resp: any;
      try {
        resp = await this.routeService.createAlteration(this.routeSelected.id, newAlteration, processingOptions);
      } catch (error: any) {
        this.onRouteRequestRejected(error, onError);
        return;
      }
      this.connectAndHandleWebSocket(
        resp,
        () => {
          this.loadingSave = false;
          this.newAlteration = false;
          this.isDuplicatingAlteration = false;
          this.renderFullScreenButton();
          this.alterationDetailsClosed = true;
          this.loadAlterations();
          this.utilsService.showNotification(
            images.notifications.check,
            `alterations.actions.create.success`,
            NotificationTypes.SUCCESS,
          );
          this.confirmChangesModal.hide();
        },
        onError,
        onError,
      );
    });
  }

  async updateAlteration(
    alteration: IRouteAlteration,
    processingOptions: IProcessingOptions,
  ) {
    this.map.data.toGeoJson(async (json: any) => {
      const cleanTerrain = this.utilsService.cleanTerrainObject(json);
      alteration.terrain = cleanTerrain;
      const onError = () => {
        this.loadingSave = false;
        this.utilsService.showNotification(images.notifications.warning, 'alterations.actions.update.error', NotificationTypes.DANGER);
      }
      let resp: any;
      try {
        resp = await this.routeService.updateAlteration(this.routeSelected.id, alteration, processingOptions);
      } catch (error: any) {
        this.onRouteRequestRejected(error, onError);
        return;
      }
      this.connectAndHandleWebSocket(
        resp,
        () => {
          this.loadingSave = false;
          this.loadAlterations();
          this.originalAlteration = structuredClone(alteration);
          this.utilsService.showNotification(
            images.notifications.check,
            'alterations.actions.update.success',
            NotificationTypes.SUCCESS,
          );
          this.editAlteration = false;
          this.confirmChangesModal.hide();
        },
        onError,
        onError,
      );
    });
  }

  private onRouteRequestRejected(error: any, onUnknownError: () => void) {
    if (!error?.error_code) {
      onUnknownError();
      return;
    }
    this.loadingSave = false;
    this.confirmChangesModal.hide();
    const title = this.literalService.get(`${error.error_code}_ERROR.title`, true);
    this.utilsService.showNotification(images.notifications.warning, '', NotificationTypes.DANGER, title, this.buildRouteErrorText(error), undefined, false);
  }

  onDuplicateAlteration(event: any) {
    if (this.selectedAlteration) {
      this.newAlterationObject = initialRouteAlterationCreate();
      this.newAlterationObject.terrain = Object.assign(
        [],
        this.selectedAlteration.terrain,
      );
      this.newAlterationBaseline = this.alterationFields(this.newAlterationObject);
      this.isDuplicatingAlteration = true;
      this.alterationDetailsClosed = false;
    }
  }

  async deleteAlteration(
    alteration: IRouteAlteration,
    processingOptions: IProcessingOptions,
  ) {
    const resp: any = await this.routeService.deleteAlteration(
      this.routeSelected.id,
      alteration.id!,
      processingOptions,
    );
    const onError = () => {
      this.loadingSave = false;
      this.utilsService.showNotification(
        images.notifications.warning,
        `alterations.actions.delete.error`,
        NotificationTypes.DANGER,
      );
    };
    this.connectAndHandleWebSocket(
      resp,
      () => {
        this.loadingSave = false;
        this.deletingAlteration = false;
        this.alterationDetailsClosed = true;
        this.loadAlterations();
        this.utilsService.showNotification(
          images.notifications.check,
          `alterations.actions.delete.success`,
          NotificationTypes.SUCCESS,
        );
        this.confirmChangesModal.hide();
      },
      onError,
      onError,
    );
  }
}
